export interface IRarHelper {
  code: string
  description: string
  dates: string
}

export class RarCodes {
  public static Codes = [
    {
      code: 'M1',
      description:
        'X-ray not taken within the past 12 months or near enough to the start of treatment.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M2',
      description: 'Not paid separately when the patient is an inpatient.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M3',
      description:
        'Equipment is the same or similar to equipment already being used.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M4',
      description:
        'Alert: This is the last monthly installment payment for this durable medical equipment.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'M5',
      description:
        'Monthly rental payments can continue until the earlier of the 15th month from the first rental month, or the month when the equipment is no longer needed.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M6',
      description:
        'Alert: You must furnish and service this item for any period of medical need for the remainder of the reasonable useful lifetime of the equipment.Start: 01/01/1997 | Last Modified: 03/01/2009Notes: (Modified 4/1/07, 3/1/2009)',
      dates: 'Start: 01/01/1997 | Last Modified: 03/01/2009Notes: (Modified 4/1/07, 3/1/2009)'
    } as IRarHelper,
    {
      code: 'M7',
      description:
        'No rental payments after the item is purchased, returned or after the total of issued rental payments equals the purchase price.Start: 01/01/1997 | Last Modified: 11/01/2016Notes: (Modified 11/1/2016)',
      dates: 'Start: 01/01/1997 | Last Modified: 11/01/2016Notes: (Modified 11/1/2016)'
    } as IRarHelper,
    {
      code: 'M8',
      description:
        'We do not accept blood gas tests results when the test was conducted by a medical supplier or taken while the patient is on oxygen.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M9',
      description:
        'Alert: This is the tenth rental month. You must offer the patient the choice of changing the rental to a purchase agreement.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'M10',
      description:
        'Equipment purchases are limited to the first or the tenth month of medical necessity.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M11',
      description:
        "DME, orthotics and prosthetics must be billed to the DME carrier who services the patient's zip code.Start: 01/01/1997",
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M12',
      description:
        'Diagnostic tests performed by a physician must indicate whether purchased services are included on the claim.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M13',
      description:
        'Only one initial visit is covered per specialty per medical group.Start: 01/01/1997 | Last Modified: 06/30/2007Notes: (Modified 6/30/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 06/30/2007Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'M14',
      description:
        'No separate payment for an injection administered during an office visit, and no payment for a full office visit if the patient only received an injection.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M15',
      description:
        'Separately billed services/tests have been bundled as they are considered components of the same procedure. Separate payment is not allowed.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M16',
      description:
        'Alert: Please see our web site, mailings, or bulletins for more details concerning this policy/procedure/decision.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Reactivated 4/1/04, Modified 11/18/05, 4/1/07)',
      dates:
        'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Reactivated 4/1/04, Modified 11/18/05, 4/1/07)'
    } as IRarHelper,
    {
      code: 'M17',
      description:
        'Alert: Payment approved as you did not know, and could not reasonably have been expected to know, that this would not normally have been covered for this patient.  In the future, you will be liable for charges for the same service(s) under the same or similar conditions.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'M18',
      description:
        "Certain services may be approved for home use.  Neither a hospital nor a Skilled Nursing Facility (SNF) is considered to be a patient's home.Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)",
      dates: 'Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'M19',
      description:
        'Missing oxygen certification/re-certification.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N234',
      dates:
        'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N234'
    } as IRarHelper,
    {
      code: 'M20',
      description:
        'Missing/incomplete/invalid HCPCS.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M21',
      description:
        'Missing/incomplete/invalid place of residence for this service/item provided in a home.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M22',
      description:
        'Missing/incomplete/invalid number of miles traveled.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M23',
      description:
        'Missing invoice.Start: 01/01/1997 | Last Modified: 08/01/2005Notes: (Modified 8/1/05)',
      dates: 'Start: 01/01/1997 | Last Modified: 08/01/2005Notes: (Modified 8/1/05)'
    } as IRarHelper,
    {
      code: 'M24',
      description:
        'Missing/incomplete/invalid number of doses per vial.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M25',
      description:
        'The information furnished does not substantiate the need for this level of service. If you believe the service should have been fully covered as billed, or if you did not know and could not reasonably have been expected to know that we would not pay for this level of service, or if you notified the patient in writing in advance that we would not pay for this level of service and he/she agreed in writing to pay, ask us to review your claim within 120 days of the date of this notice.  If you do not request an appeal, we will, upon application from the patient, reimburse him/her for the amount you have collected from him/her in excess of any deductible and coinsurance amounts. We will recover the reimbursement from you as an overpayment.Start: 01/01/1997 | Last Modified: 11/01/2010Notes: (Modified 10/1/02, 6/30/03, 8/1/05, 11/5/07, 11/1/10)',
      dates:
        'Start: 01/01/1997 | Last Modified: 11/01/2010Notes: (Modified 10/1/02, 6/30/03, 8/1/05, 11/5/07, 11/1/10)'
    } as IRarHelper,
    {
      code: 'M26',
      description:
        'The information furnished does not substantiate the need for this level of service. If you have collected any amount from the patient for this level of service /any amount that exceeds the limiting charge for the less extensive service, the law requires you to refund that amount to the patient within 30 days of receiving this notice. The requirements for refund are in 1824(I) of the Social Security Act and 42CFR411.408. The section specifies that physicians who knowingly and willfully fail to make appropriate refunds may be subject to civil monetary penalties and/or exclusion from the program. If you have any questions about this notice, please contact this office.Start: 01/01/1997 | Last Modified: 11/05/2007Notes: (Modified 10/1/02, 6/30/03, 8/1/05, 11/5/07. Also refer to N356)',
      dates:
        'Start: 01/01/1997 | Last Modified: 11/05/2007Notes: (Modified 10/1/02, 6/30/03, 8/1/05, 11/5/07. Also refer to N356)'
    } as IRarHelper,
    {
      code: 'M27',
      description:
        "Alert: The patient has been relieved of liability of payment of these items and services under the limitation of liability provision of the law. The provider is ultimately liable for the patient's waived charges, including any charges for coinsurance, since the items or services were not reasonable and necessary or constituted custodial care, and you knew or could reasonably have been expected to know, that they were not covered. You may appeal this determination. You may ask for an appeal regarding both the coverage determination and the issue of whether you exercised due care. The appeal request must be filed within 120 days of the date you receive this notice. You must make the request through this office.Start: 01/01/1997 | Last Modified: 08/01/2007Notes: (Modified 10/1/02, 8/1/05, 4/1/07, 8/1/07)",
      dates:
        'Start: 01/01/1997 | Last Modified: 08/01/2007Notes: (Modified 10/1/02, 8/1/05, 4/1/07, 8/1/07)'
    } as IRarHelper,
    {
      code: 'M28',
      description:
        'This does not qualify for payment under Part B when Part A coverage is exhausted or not otherwise available.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M29',
      description:
        'Missing operative note/report.Start: 01/01/1997 | Last Modified: 07/01/2008Notes: (Modified 2/28/03, 7/1/2008) Related to N233',
      dates:
        'Start: 01/01/1997 | Last Modified: 07/01/2008Notes: (Modified 2/28/03, 7/1/2008) Related to N233'
    } as IRarHelper,
    {
      code: 'M30',
      description:
        'Missing pathology report.Start: 01/01/1997 | Last Modified: 08/01/2004Notes: (Modified 8/1/04, 2/28/03) Related to N236',
      dates:
        'Start: 01/01/1997 | Last Modified: 08/01/2004Notes: (Modified 8/1/04, 2/28/03) Related to N236'
    } as IRarHelper,
    {
      code: 'M31',
      description:
        'Missing radiology report.Start: 01/01/1997 | Last Modified: 08/01/2004Notes: (Modified 8/1/04, 2/28/03) Related to N240',
      dates:
        'Start: 01/01/1997 | Last Modified: 08/01/2004Notes: (Modified 8/1/04, 2/28/03) Related to N240'
    } as IRarHelper,
    {
      code: 'M32',
      description:
        "Alert: This is a conditional payment made pending a decision on this service by the patient's primary payer. This payment may be subject to refund upon your receipt of any additional payment for this service from another payer. You must contact this office immediately upon receipt of an additional payment for this service.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)",
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'M33',
      description:
        'Missing/incomplete/invalid UPIN for the ordering/referring/performing provider.Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using M68',
      dates: 'Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using M68'
    } as IRarHelper,
    {
      code: 'M34',
      description:
        'Claim lacks the CLIA certification number.Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using MA120',
      dates: 'Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using MA120'
    } as IRarHelper,
    {
      code: 'M35',
      description:
        'Missing/incomplete/invalid pre-operative photos or visual field results.Start: 01/01/1997 | Stop: 02/05/2005Notes: Consider using N178',
      dates: 'Start: 01/01/1997 | Stop: 02/05/2005Notes: Consider using N178'
    } as IRarHelper,
    {
      code: 'M36',
      description:
        'This is the 11th rental month.  We cannot pay for this until you indicate that the patient has been given the option of changing the rental to a purchase.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M37',
      description:
        'Not covered when the patient is under age 35.Start: 01/01/1997 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)',
      dates: 'Start: 01/01/1997 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)'
    } as IRarHelper,
    {
      code: 'M38',
      description:
        'Alert: The patient is liable for the charges for this service as they were informed in writing before the service was furnished that we would not pay for it and the patient agreed to be responsible for the charges.Start: 01/01/1997 | Last Modified: 07/01/2015Notes: (Modified 7/1/15)',
      dates: 'Start: 01/01/1997 | Last Modified: 07/01/2015Notes: (Modified 7/1/15)'
    } as IRarHelper,
    {
      code: 'M39',
      description:
        'Alert: The patient is not liable for payment of this service as the advance notice of non-coverage you provided the patient did not comply with program requirements.Start: 01/01/1997 | Last Modified: 07/01/2015Notes: (Modified 2/1/04, 4/1/07, 11/1/09, 11/1/12, 7/1/15) Related to N563',
      dates:
        'Start: 01/01/1997 | Last Modified: 07/01/2015Notes: (Modified 2/1/04, 4/1/07, 11/1/09, 11/1/12, 7/1/15) Related to N563'
    } as IRarHelper,
    {
      code: 'M40',
      description:
        "Claim must be assigned and must be filed by the practitioner's employer.Start: 01/01/1997",
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M41',
      description:
        'We do not pay for this as the patient has no legal obligation to pay for this.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M42',
      description:
        'The medical necessity form must be personally signed by the attending physician.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M43',
      description:
        'Payment for this service previously issued to you or another provider by another carrier/intermediary.Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using Reason Code 23',
      dates: 'Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using Reason Code 23'
    } as IRarHelper,
    {
      code: 'M44',
      description:
        'Missing/incomplete/invalid condition code.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M45',
      description:
        'Missing/incomplete/invalid occurrence code(s).Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04) Related to N299',
      dates:
        'Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04) Related to N299'
    } as IRarHelper,
    {
      code: 'M46',
      description:
        'Missing/incomplete/invalid occurrence span code(s).Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04) Related to N300',
      dates:
        'Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04) Related to N300'
    } as IRarHelper,
    {
      code: 'M47',
      description:
        'Missing/incomplete/invalid Payer Claim Control Number. Other terms exist for this element including, but not limited to, Internal Control Number (ICN), Claim Control Number (CCN), Document Control Number (DCN).Start: 01/01/1997 | Last Modified: 07/01/2015Notes: (Modified 2/28/03, 7/1/15)',
      dates: 'Start: 01/01/1997 | Last Modified: 07/01/2015Notes: (Modified 2/28/03, 7/1/15)'
    } as IRarHelper,
    {
      code: 'M48',
      description:
        'Payment for services furnished to hospital inpatients (other than professional services of physicians) can only be made to the hospital.  You must request payment from the hospital rather than the patient for this service.Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using M97',
      dates: 'Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using M97'
    } as IRarHelper,
    {
      code: 'M49',
      description:
        'Missing/incomplete/invalid value code(s) or amount(s).Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M50',
      description:
        'Missing/incomplete/invalid revenue code(s).Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M51',
      description:
        'Missing/incomplete/invalid procedure code(s).Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04) Related to N301',
      dates:
        'Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04) Related to N301'
    } as IRarHelper,
    {
      code: 'M52',
      description:
        'Missing/incomplete/invalid “from” date(s) of service.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M53',
      description:
        'Missing/incomplete/invalid days or units of service.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M54',
      description:
        'Missing/incomplete/invalid total charges.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M55',
      description:
        'We do not pay for self-administered anti-emetic drugs that are not administered with a covered oral anti-cancer drug.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M56',
      description:
        'Missing/incomplete/invalid payer identifier.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M57',
      description:
        'Missing/incomplete/invalid provider identifier.Start: 01/01/1997 | Stop: 06/02/2005',
      dates: 'Start: 01/01/1997 | Stop: 06/02/2005'
    } as IRarHelper,
    {
      code: 'M58',
      description:
        'Missing/incomplete/invalid claim information.  Resubmit claim after corrections.Start: 01/01/1997 | Stop: 02/05/2005',
      dates: 'Start: 01/01/1997 | Stop: 02/05/2005'
    } as IRarHelper,
    {
      code: 'M59',
      description:
        'Missing/incomplete/invalid “to” date(s) of service.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M60',
      description:
        'Missing Certificate of Medical Necessity.Start: 01/01/1997 | Last Modified: 08/01/2004Notes: (Modified 8/1/04, 6/30/03) Related to N227',
      dates:
        'Start: 01/01/1997 | Last Modified: 08/01/2004Notes: (Modified 8/1/04, 6/30/03) Related to N227'
    } as IRarHelper,
    {
      code: 'M61',
      description:
        'We cannot pay for this as the approval period for the FDA clinical trial has expired.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M62',
      description:
        'Missing/incomplete/invalid treatment authorization code.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M63',
      description:
        'We do not pay for more than one of these on the same day.Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using M86',
      dates: 'Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using M86'
    } as IRarHelper,
    {
      code: 'M64',
      description:
        'Missing/incomplete/invalid other diagnosis.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M65',
      description:
        'One interpreting physician charge can be submitted per claim when a purchased diagnostic test is indicated. Please submit a separate claim for each interpreting physician.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M66',
      description:
        'Our records indicate that you billed diagnostic tests subject to price limitations and the procedure code submitted includes a professional component. Only the technical component is subject to price limitations.  Please submit the technical and professional components of this service as separate line items.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M67',
      description:
        'Missing/incomplete/invalid other procedure code(s).Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04) Related to N302',
      dates:
        'Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04) Related to N302'
    } as IRarHelper,
    {
      code: 'M68',
      description:
        'Missing/incomplete/invalid attending, ordering, rendering, supervising or referring physician identification.Start: 01/01/1997 | Stop: 06/02/2005',
      dates: 'Start: 01/01/1997 | Stop: 06/02/2005'
    } as IRarHelper,
    {
      code: 'M69',
      description:
        'Paid at the regular rate as you did not submit documentation to justify the modified procedure code.Start: 01/01/1997 | Last Modified: 02/01/2004Notes: (Modified 2/1/04)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/01/2004Notes: (Modified 2/1/04)'
    } as IRarHelper,
    {
      code: 'M70',
      description:
        'Alert: The NDC code submitted for this service was translated to a HCPCS code for processing, but please continue to submit the NDC on future claims for this item.Start: 01/01/1997 | Last Modified: 08/01/2007Notes: (Modified 4/1/2007, 8/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 08/01/2007Notes: (Modified 4/1/2007, 8/1/07)'
    } as IRarHelper,
    {
      code: 'M71',
      description: 'Total payment reduced due to overlap of tests billed.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M72',
      description:
        'Did not enter full 8-digit date (MM/DD/CCYY).Start: 01/01/1997 | Stop: 10/16/2003Notes: Consider using MA52',
      dates: 'Start: 01/01/1997 | Stop: 10/16/2003Notes: Consider using MA52'
    } as IRarHelper,
    {
      code: 'M73',
      description:
        'The HPSA/Physician Scarcity bonus can only be paid on the professional component of this service. Rebill as separate professional and technical components.Start: 01/01/1997 | Last Modified: 08/01/2004Notes: (Modified 8/1/04)',
      dates: 'Start: 01/01/1997 | Last Modified: 08/01/2004Notes: (Modified 8/1/04)'
    } as IRarHelper,
    {
      code: 'M74',
      description:
        'This service does not qualify for a HPSA/Physician Scarcity bonus payment.Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04)',
      dates: 'Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04)'
    } as IRarHelper,
    {
      code: 'M75',
      description:
        'Multiple automated multichannel tests performed on the same day combined for payment.Start: 01/01/1997 | Last Modified: 11/05/2007Notes: (Modified 11/5/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 11/05/2007Notes: (Modified 11/5/07)'
    } as IRarHelper,
    {
      code: 'M76',
      description:
        'Missing/incomplete/invalid diagnosis or condition.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M77',
      description:
        'Missing/incomplete/invalid/inappropriate place of service.Start: 01/01/1997 | Last Modified: 03/14/2014Notes: (Modified 2/28/03, 3/1/2014, 3/14/2014)',
      dates:
        'Start: 01/01/1997 | Last Modified: 03/14/2014Notes: (Modified 2/28/03, 3/1/2014, 3/14/2014)'
    } as IRarHelper,
    {
      code: 'M78',
      description:
        'Missing/incomplete/invalid HCPCS modifier.Start: 01/01/1997 | Stop: 05/18/2006 | Last Modified: 02/28/2003Notes: (Modified 2/28/03,) Consider using Reason Code 4',
      dates:
        'Start: 01/01/1997 | Stop: 05/18/2006 | Last Modified: 02/28/2003Notes: (Modified 2/28/03,) Consider using Reason Code 4'
    } as IRarHelper,
    {
      code: 'M79',
      description:
        'Missing/incomplete/invalid charge.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M80',
      description:
        'Not covered when performed during the same session/date as a previously processed service for the patient.Start: 01/01/1997 | Last Modified: 10/31/2002Notes: (Modified 10/31/02)',
      dates: 'Start: 01/01/1997 | Last Modified: 10/31/2002Notes: (Modified 10/31/02)'
    } as IRarHelper,
    {
      code: 'M81',
      description:
        'You are required to code to the highest level of specificity.Start: 01/01/1997 | Last Modified: 02/01/2004Notes: (Modified 2/1/04)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/01/2004Notes: (Modified 2/1/04)'
    } as IRarHelper,
    {
      code: 'M82',
      description: 'Service is not covered when patient is under age 50.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M83',
      description:
        'Service is not covered unless the patient is classified as at high risk.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M84',
      description:
        'Medical code sets used must be the codes in effect at the time of service.Start: 01/01/1997 | Last Modified: 03/14/2014Notes: (Modified 2/1/04, 3/14/2014)',
      dates: 'Start: 01/01/1997 | Last Modified: 03/14/2014Notes: (Modified 2/1/04, 3/14/2014)'
    } as IRarHelper,
    {
      code: 'M85',
      description:
        'Subjected to review of physician evaluation and management services.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M86',
      description:
        'Service denied because payment already made for same/similar procedure within set time frame.Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'M87',
      description: 'Claim/service(s) subjected to CFO-CAP prepayment review.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M88',
      description:
        'We cannot pay for laboratory tests unless billed by the laboratory that did the work.Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using Reason Code B20',
      dates: 'Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using Reason Code B20'
    } as IRarHelper,
    {
      code: 'M89',
      description: 'Not covered more than once under age 40.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M90',
      description: 'Not covered more than once in a 12 month period.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M91',
      description:
        'Lab procedures with different CLIA certification numbers must be billed on separate claims.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M92',
      description:
        'Services subjected to review under the Home Health Medical Review Initiative.Start: 01/01/1997 | Stop: 08/01/2004',
      dates: 'Start: 01/01/1997 | Stop: 08/01/2004'
    } as IRarHelper,
    {
      code: 'M93',
      description:
        'Information supplied supports a break in therapy.  A new capped rental period began with delivery of this equipment.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M94',
      description:
        'Information supplied does not support a break in therapy.  A new capped rental period will not begin.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M95',
      description:
        'Services subjected to Home Health Initiative medical review/cost report audit.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M96',
      description:
        'The technical component of a service furnished to an inpatient may only be billed by that inpatient facility. You must contact the inpatient facility for technical component reimbursement.  If not already billed, you should bill us for the professional component only.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M97',
      description:
        'Not paid to practitioner when provided to patient in this place of service.  Payment included in the reimbursement issued the facility.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M98',
      description:
        'Begin to report the Universal Product Number on claims for items of this type. We will soon begin to deny payment for items of this type if billed without the correct UPN.Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using M99',
      dates: 'Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using M99'
    } as IRarHelper,
    {
      code: 'M99',
      description:
        'Missing/incomplete/invalid Universal Product Number/Serial Number.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M100',
      description:
        'We do not pay for an oral anti-emetic drug that is not administered for use immediately before, at, or within 48 hours of administration of a covered chemotherapy drug.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M101',
      description:
        'Begin to report a G1-G5 modifier with this HCPCS.  We will soon begin to deny payment for this service if billed without a G1-G5 modifier.Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using M78',
      dates: 'Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using M78'
    } as IRarHelper,
    {
      code: 'M102',
      description:
        'Service not performed on equipment approved by the FDA for this purpose.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M103',
      description:
        'Information supplied supports a break in therapy.  However, the medical information we have for this patient does not support the need for this item as billed.  We have approved payment for this item at a reduced level, and a new capped rental period will begin with the delivery of this equipment.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M104',
      description:
        'Information supplied supports a break in therapy.  A new capped rental period will begin with delivery of the equipment.  This is the maximum approved under the fee schedule for this item or service.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M105',
      description:
        'Information supplied does not support a break in therapy.  The medical information we have for this patient does not support the need for this item as billed. We have approved payment for this item at a reduced level, and a new capped rental period will not begin.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M106',
      description:
        'Information supplied does not support a break in therapy.  A new capped rental period will not begin. This is the maximum approved under the fee schedule for this item or service.Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using MA 31',
      dates: 'Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using MA 31'
    } as IRarHelper,
    {
      code: 'M107',
      description:
        'Payment reduced as 90-day rolling average hematocrit for ESRD patient exceeded 36.5%.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M108',
      description:
        'Missing/incomplete/invalid provider identifier for the provider who interpreted the diagnostic test.Start: 01/01/1997 | Stop: 06/02/2005',
      dates: 'Start: 01/01/1997 | Stop: 06/02/2005'
    } as IRarHelper,
    {
      code: 'M109',
      description:
        'We have provided you with a bundled payment for a teleconsultation. You must send 25 percent of the teleconsultation payment to the referring practitioner.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M110',
      description:
        'Missing/incomplete/invalid provider identifier for the provider from whom you purchased interpretation services.Start: 01/01/1997 | Stop: 06/02/2005',
      dates: 'Start: 01/01/1997 | Stop: 06/02/2005'
    } as IRarHelper,
    {
      code: 'M111',
      description:
        'We do not pay for chiropractic manipulative treatment when the patient refuses to have an x-ray taken.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M112',
      description:
        'Reimbursement for this item is based on the single payment amount required under the DMEPOS Competitive Bidding Program for the area where the patient resides.Start: 01/01/1997 | Last Modified: 11/05/2007Notes: (Modified 11/5/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 11/05/2007Notes: (Modified 11/5/07)'
    } as IRarHelper,
    {
      code: 'M113',
      description:
        'Our records indicate that this patient began using this item/service prior to the current contract period for the DMEPOS Competitive Bidding Program.Start: 01/01/1997 | Last Modified: 11/05/2007Notes: (Modified 11/5/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 11/05/2007Notes: (Modified 11/5/07)'
    } as IRarHelper,
    {
      code: 'M114',
      description:
        'This service was processed in accordance with rules and guidelines under the DMEPOS Competitive Bidding Program or a Demonstration Project.  For more information regarding these projects, contact your local contractor.Start: 01/01/1997 | Last Modified: 11/05/2007Notes: (Modified 8/1/06, 11/5/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 11/05/2007Notes: (Modified 8/1/06, 11/5/07)'
    } as IRarHelper,
    {
      code: 'M115',
      description:
        'This item is denied when provided to this patient by a non-contract or non-demonstration supplier.Start: 01/01/1997 | Last Modified: 11/05/2007Notes: (Modified 11/5/2007)',
      dates: 'Start: 01/01/1997 | Last Modified: 11/05/2007Notes: (Modified 11/5/2007)'
    } as IRarHelper,
    {
      code: 'M116',
      description:
        'Processed under a demonstration project or program. Project or program is ending and additional services may not be paid under this project or program.Start: 01/01/1997 | Last Modified: 03/08/2011Notes: (Modified 2/1/04, 3/15/11)',
      dates: 'Start: 01/01/1997 | Last Modified: 03/08/2011Notes: (Modified 2/1/04, 3/15/11)'
    } as IRarHelper,
    {
      code: 'M117',
      description:
        'Not covered unless submitted via electronic claim.Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'M118',
      description:
        'Letter to follow containing further information.Start: 01/01/1997 | Stop: 01/01/2011 | Last Modified: 11/01/2009Notes: Consider using N202',
      dates:
        'Start: 01/01/1997 | Stop: 01/01/2011 | Last Modified: 11/01/2009Notes: Consider using N202'
    } as IRarHelper,
    {
      code: 'M119',
      description:
        'Missing/incomplete/invalid/ deactivated/withdrawn National Drug Code (NDC).Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 2/28/03, 4/1/04)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 2/28/03, 4/1/04)'
    } as IRarHelper,
    {
      code: 'M120',
      description:
        'Missing/incomplete/invalid provider identifier for the substituting physician who furnished the service(s) under a reciprocal billing or locum tenens arrangement.Start: 01/01/1997 | Stop: 06/02/2005',
      dates: 'Start: 01/01/1997 | Stop: 06/02/2005'
    } as IRarHelper,
    {
      code: 'M121',
      description:
        'We pay for this service only when performed with a covered cryosurgical ablation.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M122',
      description:
        'Missing/incomplete/invalid level of subluxation.Start: 01/01/1997 | Last Modified: 02/28/2006Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2006Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M123',
      description:
        'Missing/incomplete/invalid name, strength, or dosage of the drug furnished.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M124',
      description:
        'Missing indication of whether the patient owns the equipment that requires the part or supply.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N230',
      dates:
        'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N230'
    } as IRarHelper,
    {
      code: 'M125',
      description:
        'Missing/incomplete/invalid information on the period of time for which the service/supply/equipment will be needed.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M126',
      description:
        'Missing/incomplete/invalid individual lab codes included in the test.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M127',
      description:
        'Missing patient medical record for this service.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N237',
      dates:
        'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N237'
    } as IRarHelper,
    {
      code: 'M128',
      description:
        'Missing/incomplete/invalid date of the patient’s last physician visit.Start: 01/01/1997 | Stop: 06/02/2005',
      dates: 'Start: 01/01/1997 | Stop: 06/02/2005'
    } as IRarHelper,
    {
      code: 'M129',
      description:
        'Missing/incomplete/invalid indicator of x-ray availability for review.Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 2/28/03, 6/30/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 2/28/03, 6/30/03)'
    } as IRarHelper,
    {
      code: 'M130',
      description:
        'Missing invoice or statement certifying the actual cost of the lens, less discounts, and/or the type of intraocular lens used.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N231',
      dates:
        'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N231'
    } as IRarHelper,
    {
      code: 'M131',
      description:
        'Missing physician financial relationship form.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N239',
      dates:
        'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N239'
    } as IRarHelper,
    {
      code: 'M132',
      description:
        'Missing pacemaker registration form.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N235',
      dates:
        'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N235'
    } as IRarHelper,
    {
      code: 'M133',
      description:
        'Claim did not identify who performed the purchased diagnostic test or the amount you were charged for the test.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M134',
      description:
        'Performed by a facility/supplier in which the provider has a financial interest.Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'M135',
      description:
        'Missing/incomplete/invalid plan of treatment.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M136',
      description:
        'Missing/incomplete/invalid indication that the service was supervised or evaluated by a physician.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'M137',
      description:
        'Part B coinsurance under a demonstration project or pilot program.Start: 01/01/1997 | Last Modified: 11/01/2012Notes: (Modified 11/1/12)',
      dates: 'Start: 01/01/1997 | Last Modified: 11/01/2012Notes: (Modified 11/1/12)'
    } as IRarHelper,
    {
      code: 'M138',
      description:
        'Patient identified as a demonstration participant but the patient was not enrolled in the demonstration at the time services were rendered.  Coverage is limited to demonstration participants.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M139',
      description:
        'Denied services exceed the coverage limit for the demonstration.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'M140',
      description:
        'Service not covered until after the patient’s 50th birthday, i.e., no coverage prior to the day after the 50th birthdayStart: 01/01/1997 | Stop: 01/30/2004Notes: Consider using M82',
      dates: 'Start: 01/01/1997 | Stop: 01/30/2004Notes: Consider using M82'
    } as IRarHelper,
    {
      code: 'M141',
      description:
        'Missing physician certified plan of care.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N238',
      dates:
        'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N238'
    } as IRarHelper,
    {
      code: 'M142',
      description:
        'Missing American Diabetes Association Certificate of Recognition.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N226',
      dates:
        'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N226'
    } as IRarHelper,
    {
      code: 'M143',
      description:
        'The provider must update license information with the payer.Start: 01/01/1997 | Last Modified: 12/01/2006Notes: (Modified 12/1/06)',
      dates: 'Start: 01/01/1997 | Last Modified: 12/01/2006Notes: (Modified 12/1/06)'
    } as IRarHelper,
    {
      code: 'M144',
      description:
        'Pre-/post-operative care payment is included in the allowance for the surgery/procedure.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA01',
      description:
        'Alert: If you do not agree with what we approved for these services, you may appeal our decision.  To make sure that we are fair to you, we require another individual that did not process your initial claim to conduct the appeal.  However, in order to be eligible for an appeal, you must write to us within 120 days of the date you received this notice, unless you have a good reason for being late.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 10/31/02, 6/30/03, 8/1/05, 4/1/07)',
      dates:
        'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 10/31/02, 6/30/03, 8/1/05, 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA02',
      description:
        'Alert: If you do not agree with this determination, you have the right to appeal. You must file a written request for an appeal within 180 days of the date you receive this notice.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 10/31/02, 6/30/03, 8/1/05, 12/29/05, 8/1/06, 4/1/07)',
      dates:
        'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 10/31/02, 6/30/03, 8/1/05, 12/29/05, 8/1/06, 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA03',
      description:
        'If you do not agree with the approved amounts and $100 or more is in dispute (less deductible and coinsurance), you may ask for a hearing within six months of the date of this notice. To meet the $100, you may combine amounts on other claims that have been denied, including reopened appeals if you received a revised decision. You must appeal each claim on time.Start: 01/01/1997 | Stop: 10/01/2006 | Last Modified: 11/18/2005Notes: Consider using MA02 (Modified 10/31/02, 6/30/03, 8/1/05, 11/18/05)',
      dates:
        'Start: 01/01/1997 | Stop: 10/01/2006 | Last Modified: 11/18/2005Notes: Consider using MA02 (Modified 10/31/02, 6/30/03, 8/1/05, 11/18/05)'
    } as IRarHelper,
    {
      code: 'MA04',
      description:
        'Secondary payment cannot be considered without the identity of or payment information from the primary payer.  The information was either not reported or was illegible.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA05',
      description:
        'Incorrect admission date patient status or type of bill entry on claim.Start: 01/01/1997 | Stop: 10/16/2003Notes: Consider using MA30, MA40 or MA43',
      dates: 'Start: 01/01/1997 | Stop: 10/16/2003Notes: Consider using MA30, MA40 or MA43'
    } as IRarHelper,
    {
      code: 'MA06',
      description:
        'Missing/incomplete/invalid beginning and/or ending date(s).Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using MA31',
      dates: 'Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using MA31'
    } as IRarHelper,
    {
      code: 'MA07',
      description:
        'Alert: The claim information has also been forwarded to Medicaid for review.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA08',
      description:
        'Alert: Claim information was not forwarded because the supplemental coverage is not with a Medigap plan, or you do not participate in Medicare.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA09',
      description:
        'Alert: Claim submitted as unassigned but processed as assigned in accordance with our current assignment/participation agreement.Start: 01/01/1997 | Last Modified: 11/01/2015Notes: (Modified 11/1/2014, 11/1/2015)',
      dates: 'Start: 01/01/1997 | Last Modified: 11/01/2015Notes: (Modified 11/1/2014, 11/1/2015)'
    } as IRarHelper,
    {
      code: 'MA10',
      description:
        "Alert: The patient's payment was in excess of the amount owed.  You must refund the overpayment to the patient.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)",
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA11',
      description:
        "Payment is being issued on a conditional basis.  If no-fault insurance, liability insurance, Workers' Compensation, Department of Veterans Affairs, or a group health plan for employees and dependents also covers this claim, a refund may be due us.  Please contact us if the patient is covered by any of these sources.Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using M32",
      dates: 'Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using M32'
    } as IRarHelper,
    {
      code: 'MA12',
      description:
        'You have not established that you have the right under the law to bill for services furnished by the person(s) that furnished this (these) service(s).Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA13',
      description:
        'Alert: You may be subject to penalties if you bill the patient for amounts not reported with the PR (patient responsibility) group code.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA14',
      description:
        'Alert: The patient is a member of an employer-sponsored prepaid health plan. Services from outside that health plan are not covered.  However, as you were not previously notified of this, we are paying this time.  In the future, we will not pay you for non-plan services.Start: 01/01/1997 | Last Modified: 08/01/2007Notes: (Modified 4/1/07, 8/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 08/01/2007Notes: (Modified 4/1/07, 8/1/07)'
    } as IRarHelper,
    {
      code: 'MA15',
      description:
        'Alert: Your claim has been separated to expedite handling. You will receive a separate notice for the other services reported.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA16',
      description:
        'The patient is covered by the Black Lung Program.  Send this claim to the Department of Labor, Federal Black Lung Program, P.O. Box 828, Lanham-Seabrook MD 20703.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA17',
      description:
        "We are the primary payer and have paid at the primary rate.  You must contact the patient's other insurer to refund any excess it may have paid due to its erroneous primary payment.Start: 01/01/1997",
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA18',
      description:
        "Alert: The claim information is also being forwarded to the patient's supplemental insurer. Send any questions regarding supplemental benefits to them.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)",
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA19',
      description:
        'Alert:  Information was not sent to the Medigap insurer due to incorrect/invalid information you submitted concerning that insurer. Please verify your information and submit your secondary claim directly to that insurer.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA20',
      description:
        'Skilled Nursing Facility (SNF) stay not covered when care is primarily related to the use of an urethral catheter for convenience or the control of incontinence.Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'MA21',
      description: 'SSA records indicate mismatch with name and sex.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA22',
      description: 'Payment of less than $1.00 suppressed.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA23',
      description: 'Demand bill approved as result of medical review.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA24',
      description:
        'Christian Science Sanitarium/ Skilled Nursing Facility (SNF) bill in the same benefit period.Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'MA25',
      description:
        'A patient may not elect to change a hospice provider more than once in a benefit period.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA26',
      description:
        'Alert: Our records indicate that you were previously informed of this rule.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA27',
      description:
        'Missing/incomplete/invalid entitlement number or name shown on the claim.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA28',
      description:
        'Alert: Receipt of this notice by a physician or supplier who did not accept assignment is for information only and does not make the physician or supplier a party to the determination.  No additional rights to appeal this decision, above those rights already provided for by regulation/instruction, are conferred by receipt of this notice.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA29',
      description:
        'Missing/incomplete/invalid provider name, city, state, or zip code.Start: 01/01/1997 | Stop: 06/02/2005',
      dates: 'Start: 01/01/1997 | Stop: 06/02/2005'
    } as IRarHelper,
    {
      code: 'MA30',
      description:
        'Missing/incomplete/invalid type of bill.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA31',
      description:
        'Missing/incomplete/invalid beginning and ending dates of the period billed.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA32',
      description:
        'Missing/incomplete/invalid number of covered days during the billing period.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA33',
      description:
        'Missing/incomplete/invalid noncovered days during the billing period.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA34',
      description:
        'Missing/incomplete/invalid number of coinsurance days during the billing period.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA35',
      description:
        'Missing/incomplete/invalid number of lifetime reserve days.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA36',
      description:
        'Missing/incomplete/invalid patient name.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA37',
      description:
        "Missing/incomplete/invalid patient's address.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)",
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA38',
      description: 'Missing/incomplete/invalid birth date.Start: 01/01/1997 | Stop: 06/02/2005',
      dates: 'Start: 01/01/1997 | Stop: 06/02/2005'
    } as IRarHelper,
    {
      code: 'MA39',
      description:
        'Missing/incomplete/invalid gender.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA40',
      description:
        'Missing/incomplete/invalid admission date.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA41',
      description:
        'Missing/incomplete/invalid admission type.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA42',
      description:
        'Missing/incomplete/invalid admission source.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA43',
      description:
        'Missing/incomplete/invalid patient status.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA44',
      description:
        'Alert: No appeal rights. Adjudicative decision based on law.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA45',
      description:
        'Alert: As previously advised, a portion or all of your payment is being held in a special account.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA46',
      description:
        'Alert: The new information was considered but additional payment will not be issued.Start: 01/01/1997 | Last Modified: 11/01/2015Notes: (Modified 3/1/2009, 11/1/2015)',
      dates: 'Start: 01/01/1997 | Last Modified: 11/01/2015Notes: (Modified 3/1/2009, 11/1/2015)'
    } as IRarHelper,
    {
      code: 'MA47',
      description:
        'Our records show you have opted out of Medicare, agreeing with the patient not to bill Medicare for services/tests/supplies furnished.  As result, we cannot pay this claim. The patient is responsible for payment.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA48',
      description:
        'Missing/incomplete/invalid name or address of responsible party or primary payer.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA49',
      description:
        'Missing/incomplete/invalid six-digit provider identifier for home health agency or hospice for physician(s) performing care plan oversight services.Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using MA76',
      dates: 'Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using MA76'
    } as IRarHelper,
    {
      code: 'MA50',
      description:
        'Missing/incomplete/invalid Investigational Device Exemption number or Clinical Trial number.Start: 01/01/1997 | Last Modified: 03/01/2014Notes: (Modified  2/28/03, 3/1/2014)',
      dates: 'Start: 01/01/1997 | Last Modified: 03/01/2014Notes: (Modified  2/28/03, 3/1/2014)'
    } as IRarHelper,
    {
      code: 'MA51',
      description:
        'Missing/incomplete/invalid CLIA certification number for laboratory services billed by physician office laboratory.Start: 01/01/1997 | Stop: 02/05/2005Notes: Consider using MA120',
      dates: 'Start: 01/01/1997 | Stop: 02/05/2005Notes: Consider using MA120'
    } as IRarHelper,
    {
      code: 'MA52',
      description: 'Missing/incomplete/invalid date.Start: 01/01/1997 | Stop: 06/02/2005',
      dates: 'Start: 01/01/1997 | Stop: 06/02/2005'
    } as IRarHelper,
    {
      code: 'MA53',
      description:
        'Missing/incomplete/invalid Competitive Bidding Demonstration Project identification.Start: 01/01/1997 | Last Modified: 02/01/2004Notes: (Modified 2/1/04)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/01/2004Notes: (Modified 2/1/04)'
    } as IRarHelper,
    {
      code: 'MA54',
      description:
        'Physician certification or election consent for hospice care not received timely.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA55',
      description:
        'Not covered as patient received medical health care services, automatically revoking his/her election to receive religious non-medical health care services.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA56',
      description:
        'Our records show you have opted out of Medicare, agreeing with the patient not to bill Medicare for services/tests/supplies furnished.  As result, we cannot pay this claim. The patient is responsible for payment, but under Federal law, you cannot charge the patient more than the limiting charge amount.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA57',
      description:
        'Patient submitted written request to revoke his/her election for religious non-medical health care services.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA58',
      description:
        'Missing/incomplete/invalid release of information indicator.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA59',
      description:
        'Alert: The patient overpaid you for these services. You must issue the patient a refund within 30 days for the difference between his/her payment and the total amount shown as patient responsibility on this notice.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA60',
      description:
        'Missing/incomplete/invalid patient relationship to insured.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA61',
      description:
        'Missing/incomplete/invalid social security number.Start: 01/01/1997 | Last Modified: 03/01/2018Notes: (Modified 2/28/03, 3/1/2018)',
      dates: 'Start: 01/01/1997 | Last Modified: 03/01/2018Notes: (Modified 2/28/03, 3/1/2018)'
    } as IRarHelper,
    {
      code: 'MA62',
      description:
        'Alert: This is a telephone review decision.Start: 01/01/1997 | Last Modified: 08/01/2007Notes: (Modified 4/1/07, 8/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 08/01/2007Notes: (Modified 4/1/07, 8/1/07)'
    } as IRarHelper,
    {
      code: 'MA63',
      description:
        'Missing/incomplete/invalid principal diagnosis.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA64',
      description:
        'Our records indicate that we should be the third payer for this claim.  We cannot process this claim until we have received payment information from the primary and secondary payers.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA65',
      description:
        'Missing/incomplete/invalid admitting diagnosis.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA66',
      description:
        'Missing/incomplete/invalid principal procedure code.Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04) Related to N303',
      dates:
        'Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04) Related to N303'
    } as IRarHelper,
    {
      code: 'MA67',
      description:
        'Alert: Correction to a prior claim.Start: 01/01/1997 | Last Modified: 11/01/2015Notes: (Modified 11/1/2015)',
      dates: 'Start: 01/01/1997 | Last Modified: 11/01/2015Notes: (Modified 11/1/2015)'
    } as IRarHelper,
    {
      code: 'MA68',
      description:
        'Alert: We did not crossover this claim because the secondary insurance information on the claim was incomplete. Please supply complete information or use the PLANID of the insurer to assure correct and timely routing of the claim.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA69',
      description:
        'Missing/incomplete/invalid remarks.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA70',
      description:
        'Missing/incomplete/invalid provider representative signature.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA71',
      description:
        'Missing/incomplete/invalid provider representative signature date.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA72',
      description:
        'Alert: The patient overpaid you for these assigned services.  You must issue the patient a refund within 30 days for the difference between his/her payment to you and the total of the amount shown as patient responsibility and as paid to the patient on this notice.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA73',
      description:
        'Informational remittance associated with a Medicare demonstration.  No payment issued under fee-for-service Medicare as patient has elected managed care.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA74',
      description:
        'Alert: This payment replaces an earlier payment for this claim that was either lost, damaged or returned.Start: 01/01/1997 | Last Modified: 07/01/2015Notes: (Modified 7/1/15)',
      dates: 'Start: 01/01/1997 | Last Modified: 07/01/2015Notes: (Modified 7/1/15)'
    } as IRarHelper,
    {
      code: 'MA75',
      description:
        'Missing/incomplete/invalid patient or authorized representative signature.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA76',
      description:
        'Missing/incomplete/invalid provider identifier for home health agency or hospice when physician is performing care plan oversight services.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03, 2/1/04)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03, 2/1/04)'
    } as IRarHelper,
    {
      code: 'MA77',
      description:
        'Alert: The patient overpaid you. You must issue the patient a refund within 30 days for the difference between the patient’s payment less the total of our and other payer payments and the amount shown as patient responsibility on this notice.Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/1997 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'MA78',
      description:
        'The patient overpaid you.  You must issue the patient a refund within 30 days for the difference between our allowed amount total and the amount paid by the patient.Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using MA59',
      dates: 'Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using MA59'
    } as IRarHelper,
    {
      code: 'MA79',
      description: 'Billed in excess of interim rate.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA80',
      description:
        'Informational notice. No payment issued for this claim with this notice. Payment issued to the hospital by its intermediary for all services for this encounter under a demonstration project.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA81',
      description:
        'Missing/incomplete/invalid provider/supplier signature.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA82',
      description:
        'Missing/incomplete/invalid provider/supplier billing number/identifier or billing name, address, city, state, zip code, or phone number.Start: 01/01/1997 | Stop: 06/02/2005',
      dates: 'Start: 01/01/1997 | Stop: 06/02/2005'
    } as IRarHelper,
    {
      code: 'MA83',
      description:
        'Did not indicate whether we are the primary or secondary payer.Start: 01/01/1997 | Last Modified: 08/01/2005Notes: (Modified 8/1/05)',
      dates: 'Start: 01/01/1997 | Last Modified: 08/01/2005Notes: (Modified 8/1/05)'
    } as IRarHelper,
    {
      code: 'MA84',
      description:
        'Patient identified as participating in the National Emphysema Treatment Trial but our records indicate that this patient is either not a participant, or has not yet been approved for this phase of the study.  Contact Johns Hopkins University, the study coordinator, to resolve if there was a discrepancy.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA85',
      description:
        'Our records indicate that a primary payer exists (other than ourselves); however, you did not complete or enter accurately the insurance plan/group/program name or identification number.  Enter the PlanID when effective.Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using MA92',
      dates: 'Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using MA92'
    } as IRarHelper,
    {
      code: 'MA86',
      description:
        'Missing/incomplete/invalid group or policy number of the insured for the primary coverage.Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using MA92',
      dates: 'Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using MA92'
    } as IRarHelper,
    {
      code: 'MA87',
      description:
        "Missing/incomplete/invalid insured's name for the primary payer.Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using MA92",
      dates: 'Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using MA92'
    } as IRarHelper,
    {
      code: 'MA88',
      description:
        "Missing/incomplete/invalid insured's address and/or telephone number for the primary payer.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)",
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA89',
      description:
        "Missing/incomplete/invalid patient's relationship to the insured for the primary payer.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)",
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA90',
      description:
        'Missing/incomplete/invalid employment status code for the primary insured.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03).',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03).'
    } as IRarHelper,
    {
      code: 'MA91',
      description:
        'Alert: This determination is the result of the appeal you filed.Start: 01/01/1997 | Last Modified: 07/01/2015Notes: (Modified 7/1/15)',
      dates: 'Start: 01/01/1997 | Last Modified: 07/01/2015Notes: (Modified 7/1/15)'
    } as IRarHelper,
    {
      code: 'MA92',
      description:
        'Missing plan information for other insurance.Start: 01/01/1997 | Last Modified: 02/01/2004Notes: (Modified 2/1/04) Related to N245',
      dates: 'Start: 01/01/1997 | Last Modified: 02/01/2004Notes: (Modified 2/1/04) Related to N245'
    } as IRarHelper,
    {
      code: 'MA93',
      description:
        'Non-PIP (Periodic Interim Payment) claim.Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'MA94',
      description:
        'Did not enter the statement “Attending physician not hospice employee” on the claim form to certify that the rendering physician is not an employee of the hospice.Start: 01/01/1997 | Last Modified: 08/01/2005Notes: (Reactivated 4/1/04, Modified 8/1/05)',
      dates:
        'Start: 01/01/1997 | Last Modified: 08/01/2005Notes: (Reactivated 4/1/04, Modified 8/1/05)'
    } as IRarHelper,
    {
      code: 'MA95',
      description:
        'A not otherwise classified or unlisted procedure code(s) was billed but a narrative description of the procedure was not entered on the claim.  Refer to item 19 on the HCFA-1500.Start: 01/01/1997 | Stop: 01/01/2004 | Last Modified: 02/28/2003Notes: (Deactivated 2/28/2003) (Erroneous description corrected 9/2/2008) Consider using M51',
      dates:
        'Start: 01/01/1997 | Stop: 01/01/2004 | Last Modified: 02/28/2003Notes: (Deactivated 2/28/2003) (Erroneous description corrected 9/2/2008) Consider using M51'
    } as IRarHelper,
    {
      code: 'MA96',
      description:
        'Claim rejected. Coded as a Medicare Managed Care Demonstration but patient is not enrolled in a Medicare managed care plan.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA97',
      description:
        'Missing/incomplete/invalid Medicare Managed Care Demonstration contract number or clinical trial registry number.Start: 01/01/1997 | Last Modified: 02/29/2008Notes: (Modified 2/29/08)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/29/2008Notes: (Modified 2/29/08)'
    } as IRarHelper,
    {
      code: 'MA98',
      description:
        'Claim Rejected. Does not contain the correct Medicare Managed Care Demonstration contract number for this beneficiary.Start: 01/01/1997 | Stop: 10/16/2003Notes: Consider using MA97',
      dates: 'Start: 01/01/1997 | Stop: 10/16/2003Notes: Consider using MA97'
    } as IRarHelper,
    {
      code: 'MA99',
      description:
        'Missing/incomplete/invalid Medigap information.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA100',
      description:
        'Missing/incomplete/invalid date of current illness or symptoms.Start: 01/01/1997 | Last Modified: 03/14/2014Notes: (Modified 2/28/03, 3/30/05, 3/14/2014)',
      dates:
        'Start: 01/01/1997 | Last Modified: 03/14/2014Notes: (Modified 2/28/03, 3/30/05, 3/14/2014)'
    } as IRarHelper,
    {
      code: 'MA101',
      description:
        'A Skilled Nursing Facility (SNF) is responsible for payment of outside providers who furnish these services/supplies to residents.Start: 01/01/1997 | Stop: 01/01/2011 | Last Modified: 06/30/2003Notes: Consider using N538',
      dates:
        'Start: 01/01/1997 | Stop: 01/01/2011 | Last Modified: 06/30/2003Notes: Consider using N538'
    } as IRarHelper,
    {
      code: 'MA102',
      description:
        'Missing/incomplete/invalid name or provider identifier for the rendering/referring/ ordering/ supervising provider.Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using M68',
      dates: 'Start: 01/01/1997 | Stop: 08/01/2004Notes: Consider using M68'
    } as IRarHelper,
    {
      code: 'MA103',
      description: 'Hemophilia Add On.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA104',
      description:
        'Missing/incomplete/invalid date the patient was last seen or the provider identifier of the attending physician.Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using M128 or M57',
      dates: 'Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using M128 or M57'
    } as IRarHelper,
    {
      code: 'MA105',
      description:
        'Missing/incomplete/invalid provider number for this place of service.Start: 01/01/1997 | Stop: 06/02/2005',
      dates: 'Start: 01/01/1997 | Stop: 06/02/2005'
    } as IRarHelper,
    {
      code: 'MA106',
      description:
        'PIP (Periodic Interim Payment) claim.Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'MA107',
      description:
        'Paper claim contains more than three separate data items in field 19.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA108',
      description: 'Paper claim contains more than one data item in field 23.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA109',
      description:
        'Claim processed in accordance with ambulatory surgical guidelines.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA110',
      description:
        'Missing/incomplete/invalid information on whether the diagnostic test(s) were performed by an outside entity or if no purchased tests are included on the claim.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA111',
      description:
        "Missing/incomplete/invalid purchase price of the test(s) and/or the performing laboratory's name and address.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)",
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA112',
      description:
        'Missing/incomplete/invalid group practice information.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA113',
      description:
        'Incomplete/invalid taxpayer identification number (TIN) submitted by you per the Internal Revenue Service. Your claims cannot be processed without your correct TIN, and you may not bill the patient pending correction of your TIN.  There are no appeal rights for unprocessable claims, but you may resubmit this claim after you have notified this office of your correct TIN.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA114',
      description:
        'Missing/incomplete/invalid information on where the services were furnished.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA115',
      description:
        'Missing/incomplete/invalid physical location (name and address, or PIN) where the service(s) were rendered in a Health Professional Shortage Area (HPSA).Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA116',
      description:
        "Did not complete the statement 'Homebound' on the claim to validate whether laboratory services were performed at home or in an institution.Start: 01/01/1997Notes: (Reactivated 4/1/04)",
      dates: 'Start: 01/01/1997Notes: (Reactivated 4/1/04)'
    } as IRarHelper,
    {
      code: 'MA117',
      description: 'This claim has been assessed a $1.00 user fee.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA118',
      description:
        'Alert: No Medicare payment issued for this claim for services or supplies furnished to a Medicare-eligible veteran through a facility of the Department of Veterans Affairs. Coinsurance and/or deductible are applicable.Start: 01/01/1997 | Last Modified: 11/01/2014',
      dates: 'Start: 01/01/1997 | Last Modified: 11/01/2014'
    } as IRarHelper,
    {
      code: 'MA119',
      description:
        'Provider level adjustment for late claim filing applies to this claim.Start: 01/01/1997 | Stop: 05/01/2008 | Last Modified: 11/05/2007Notes: Consider using Reason Code B4',
      dates:
        'Start: 01/01/1997 | Stop: 05/01/2008 | Last Modified: 11/05/2007Notes: Consider using Reason Code B4'
    } as IRarHelper,
    {
      code: 'MA120',
      description:
        'Missing/incomplete/invalid CLIA certification number.Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/1997 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'MA121',
      description:
        'Missing/incomplete/invalid x-ray date.Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04)',
      dates: 'Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04)'
    } as IRarHelper,
    {
      code: 'MA122',
      description:
        'Missing/incomplete/invalid initial treatment date.Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04)',
      dates: 'Start: 01/01/1997 | Last Modified: 12/02/2004Notes: (Modified 12/2/04)'
    } as IRarHelper,
    {
      code: 'MA123',
      description:
        'Your center was not selected to participate in this study, therefore, we cannot pay for these services.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA124',
      description:
        'Processed for IME only.Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using Reason Code 74',
      dates: 'Start: 01/01/1997 | Stop: 01/31/2004Notes: Consider using Reason Code 74'
    } as IRarHelper,
    {
      code: 'MA125',
      description:
        'Per legislation governing this program, payment constitutes payment in full.Start: 01/01/1997',
      dates: 'Start: 01/01/1997'
    } as IRarHelper,
    {
      code: 'MA126',
      description:
        'Pancreas transplant not covered unless kidney transplant performed.Start: 10/12/2001',
      dates: 'Start: 10/12/2001'
    } as IRarHelper,
    {
      code: 'MA127',
      description: 'Reserved for future use.Start: 10/12/2001 | Stop: 06/02/2005',
      dates: 'Start: 10/12/2001 | Stop: 06/02/2005'
    } as IRarHelper,
    {
      code: 'MA128',
      description:
        'Missing/incomplete/invalid FDA approval number.Start: 10/12/2001 | Last Modified: 03/30/2005Notes: (Modified 2/28/03, 3/30/05)',
      dates: 'Start: 10/12/2001 | Last Modified: 03/30/2005Notes: (Modified 2/28/03, 3/30/05)'
    } as IRarHelper,
    {
      code: 'MA129',
      description:
        'This provider was not certified for this procedure on this date of service.Start: 10/12/2001 | Stop: 01/31/2004 | Last Modified: 01/31/2004Notes: Consider using MA120 and Reason Code B7',
      dates:
        'Start: 10/12/2001 | Stop: 01/31/2004 | Last Modified: 01/31/2004Notes: Consider using MA120 and Reason Code B7'
    } as IRarHelper,
    {
      code: 'MA130',
      description:
        'Your claim contains incomplete and/or invalid information, and no appeal rights are afforded because the claim is unprocessable.  Please submit a new claim with the complete/correct information.Start: 10/12/2001',
      dates: 'Start: 10/12/2001'
    } as IRarHelper,
    {
      code: 'MA131',
      description:
        'Physician already paid for services in conjunction with this demonstration claim.  You must have the physician withdraw that claim and refund the payment before we can process your claim.Start: 10/12/2001',
      dates: 'Start: 10/12/2001'
    } as IRarHelper,
    {
      code: 'MA132',
      description: 'Adjustment to the pre-demonstration rate.Start: 10/12/2001',
      dates: 'Start: 10/12/2001'
    } as IRarHelper,
    {
      code: 'MA133',
      description:
        'Claim overlaps inpatient stay. Rebill only those services rendered outside the inpatient stay.Start: 10/12/2001',
      dates: 'Start: 10/12/2001'
    } as IRarHelper,
    {
      code: 'MA134',
      description:
        'Missing/incomplete/invalid provider number of the facility where the patient resides.Start: 10/12/2001',
      dates: 'Start: 10/12/2001'
    } as IRarHelper,
    {
      code: 'N1',
      description:
        'Alert: You may appeal this decision in writing within the required time limits following receipt of this notice by following the instructions included in your contract, plan benefit documents or jurisdiction statutes.Start: 01/01/2000 | Last Modified: 07/15/2013Notes: (Modified 2/28/03, 4/1/07, 7/15/13)',
      dates:
        'Start: 01/01/2000 | Last Modified: 07/15/2013Notes: (Modified 2/28/03, 4/1/07, 7/15/13)'
    } as IRarHelper,
    {
      code: 'N2',
      description:
        'This allowance has been made in accordance with the most appropriate course of treatment provision of the plan.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N3',
      description:
        'Missing consent form.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N228',
      dates:
        'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03) Related to N228'
    } as IRarHelper,
    {
      code: 'N4',
      description:
        'Missing/Incomplete/Invalid prior Insurance Carrier(s) EOB.Start: 01/01/2000 | Last Modified: 03/06/2012Notes: (Modified 2/28/03, 3/6/2012)',
      dates: 'Start: 01/01/2000 | Last Modified: 03/06/2012Notes: (Modified 2/28/03, 3/6/2012)'
    } as IRarHelper,
    {
      code: 'N5',
      description: 'EOB received from previous payer.  Claim not on file.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N6',
      description:
        'Under FEHB law (U.S.C. 8904(b)), we cannot pay more for covered care than the amount Medicare would have allowed if the patient were enrolled in Medicare Part A and/or Medicare Part B.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N7',
      description:
        'Alert: Processing of this claim/service has included consideration under Major Medical provisions.Start: 01/01/2000 | Last Modified: 07/15/2013Notes: (Modified 7/15/13)',
      dates: 'Start: 01/01/2000 | Last Modified: 07/15/2013Notes: (Modified 7/15/13)'
    } as IRarHelper,
    {
      code: 'N8',
      description:
        'Crossover claim denied by previous payer and complete claim data not forwarded. Resubmit this claim to this payer to provide adequate data for adjudication.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N9',
      description:
        'Adjustment represents the estimated amount a previous payer may pay.Start: 01/01/2000 | Last Modified: 11/18/2005Notes: (Modified 11/18/05)',
      dates: 'Start: 01/01/2000 | Last Modified: 11/18/2005Notes: (Modified 11/18/05)'
    } as IRarHelper,
    {
      code: 'N10',
      description:
        'Adjustment based on the findings of a review organization/professional consult/manual adjudication/medical advisor/dental advisor/peer review.Start: 01/01/2000 | Last Modified: 03/01/2015Notes: (Modified 10/31/02, 7/1/08, 7/15/13, 3/1/2015)',
      dates:
        'Start: 01/01/2000 | Last Modified: 03/01/2015Notes: (Modified 10/31/02, 7/1/08, 7/15/13, 3/1/2015)'
    } as IRarHelper,
    {
      code: 'N11',
      description: 'Denial reversed because of medical review.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N12',
      description:
        'Policy provides coverage supplemental to Medicare. As the member does not appear to be enrolled in the applicable part of Medicare, the member is responsible for payment of the portion of the charge that would have been covered by Medicare.Start: 01/01/2000 | Last Modified: 08/01/2007Notes: (Modified 8/1/07)',
      dates: 'Start: 01/01/2000 | Last Modified: 08/01/2007Notes: (Modified 8/1/07)'
    } as IRarHelper,
    {
      code: 'N13',
      description:
        'Payment based on professional/technical component modifier(s).Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N14',
      description:
        'Payment based on a contractual amount or agreement, fee schedule, or maximum allowable amount.Start: 01/01/2000 | Stop: 10/01/2007Notes: Consider using Reason Code 45',
      dates: 'Start: 01/01/2000 | Stop: 10/01/2007Notes: Consider using Reason Code 45'
    } as IRarHelper,
    {
      code: 'N15',
      description: 'Services for a newborn must be billed separately.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N16',
      description:
        'Family/member Out-of-Pocket maximum has been met. Payment based on a higher percentage.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N17',
      description:
        'Per admission deductible.Start: 01/01/2000 | Stop: 08/01/2004Notes: Consider using Reason Code 1',
      dates: 'Start: 01/01/2000 | Stop: 08/01/2004Notes: Consider using Reason Code 1'
    } as IRarHelper,
    {
      code: 'N18',
      description:
        'Payment based on the Medicare allowed amount.Start: 01/01/2000 | Stop: 01/31/2004Notes: Consider using N14',
      dates: 'Start: 01/01/2000 | Stop: 01/31/2004Notes: Consider using N14'
    } as IRarHelper,
    {
      code: 'N19',
      description: 'Procedure code incidental to primary procedure.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N20',
      description:
        'Service not payable with other service rendered on the same date.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N21',
      description:
        'Alert: Your line item has been separated into multiple lines to expedite handling.Start: 01/01/2000 | Last Modified: 04/01/2007Notes: (Modified 8/1/05, 4/1/07)',
      dates: 'Start: 01/01/2000 | Last Modified: 04/01/2007Notes: (Modified 8/1/05, 4/1/07)'
    } as IRarHelper,
    {
      code: 'N22',
      description:
        'Alert: This procedure code was added/changed because it more accurately describes the services rendered.Start: 01/01/2000 | Last Modified: 07/01/2015Notes: (Modified 10/31/02, 2/28/03, 7/1/15)',
      dates:
        'Start: 01/01/2000 | Last Modified: 07/01/2015Notes: (Modified 10/31/02, 2/28/03, 7/1/15)'
    } as IRarHelper,
    {
      code: 'N23',
      description:
        'Alert: Patient liability may be affected due to coordination of benefits with other carriers and/or maximum benefit provisions.Start: 01/01/2000 | Last Modified: 04/01/2007Notes: (Modified 8/13/01, 4/1/07)',
      dates: 'Start: 01/01/2000 | Last Modified: 04/01/2007Notes: (Modified 8/13/01, 4/1/07)'
    } as IRarHelper,
    {
      code: 'N24',
      description:
        'Missing/incomplete/invalid Electronic Funds Transfer (EFT) banking information.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N25',
      description:
        'This company has been contracted by your benefit plan to provide administrative claims payment services only.  This company does not assume financial risk or obligation with respect to claims processed on behalf of your benefit plan.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N26',
      description:
        'Missing itemized bill/statement.Start: 01/01/2000 | Last Modified: 07/01/2008Notes: (Modified 2/28/03, 7/1/2008) Related to N232',
      dates:
        'Start: 01/01/2000 | Last Modified: 07/01/2008Notes: (Modified 2/28/03, 7/1/2008) Related to N232'
    } as IRarHelper,
    {
      code: 'N27',
      description:
        'Missing/incomplete/invalid treatment number.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N28',
      description: 'Consent form requirements not fulfilled.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N29',
      description:
        'Missing documentation/orders/notes/summary/report/chart.Start: 01/01/2000 | Stop: 03/01/2016 | Last Modified: 03/01/2014Notes: (Modified 2/28/03, 8/1/05, 3/1/2014) Related to N225, Explicit RARCs have been approved, this non-specific RARC will be deactivated in March 2016.',
      dates:
        'Start: 01/01/2000 | Stop: 03/01/2016 | Last Modified: 03/01/2014Notes: (Modified 2/28/03, 8/1/05, 3/1/2014) Related to N225, Explicit RARCs have been approved, this non-specific RARC will be deactivated in March 2016.'
    } as IRarHelper,
    {
      code: 'N30',
      description:
        'Patient ineligible for this service.Start: 01/01/2000 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'N31',
      description:
        'Missing/incomplete/invalid prescribing provider identifier.Start: 01/01/2000 | Last Modified: 12/02/2004Notes: (Modified 12/2/04)',
      dates: 'Start: 01/01/2000 | Last Modified: 12/02/2004Notes: (Modified 12/2/04)'
    } as IRarHelper,
    {
      code: 'N32',
      description:
        'Claim must be submitted by the provider who rendered the service.Start: 01/01/2000 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'N33',
      description: 'No record of health check prior to initiation of treatment.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N34',
      description:
        'Incorrect claim form/format for this service.Start: 01/01/2000 | Last Modified: 11/18/2005Notes: (Modified 11/18/05)',
      dates: 'Start: 01/01/2000 | Last Modified: 11/18/2005Notes: (Modified 11/18/05)'
    } as IRarHelper,
    {
      code: 'N35',
      description: 'Program integrity/utilization review decision.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N36',
      description:
        'Claim must meet primary payer’s processing requirements before we can consider payment.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N37',
      description:
        'Missing/incomplete/invalid tooth number/letter.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N38',
      description:
        'Missing/incomplete/invalid place of service.Start: 01/01/2000 | Stop: 02/05/2005Notes: Consider using M77',
      dates: 'Start: 01/01/2000 | Stop: 02/05/2005Notes: Consider using M77'
    } as IRarHelper,
    {
      code: 'N39',
      description: 'Procedure code is not compatible with tooth number/letter.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N40',
      description:
        'Missing radiology film(s)/image(s).Start: 01/01/2000 | Last Modified: 07/01/2008Notes: (Modified 2/1/04, 7/1/08) Related to N242',
      dates:
        'Start: 01/01/2000 | Last Modified: 07/01/2008Notes: (Modified 2/1/04, 7/1/08) Related to N242'
    } as IRarHelper,
    {
      code: 'N41',
      description:
        'Authorization request denied.Start: 01/01/2000 | Stop: 10/16/2003Notes: Consider using Reason Code 39',
      dates: 'Start: 01/01/2000 | Stop: 10/16/2003Notes: Consider using Reason Code 39'
    } as IRarHelper,
    {
      code: 'N42',
      description: 'Missing mental health assessment.Start: 01/01/2000 | Last Modified: 11/01/2014',
      dates: 'Start: 01/01/2000 | Last Modified: 11/01/2014'
    } as IRarHelper,
    {
      code: 'N43',
      description: 'Bed hold or leave days exceeded.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N44',
      description:
        'Payer’s share of regulatory surcharges, assessments, allowances or health care-related taxes paid directly to the regulatory authority.Start: 01/01/2000 | Stop: 10/16/2003Notes: Consider using Reason Code 137',
      dates: 'Start: 01/01/2000 | Stop: 10/16/2003Notes: Consider using Reason Code 137'
    } as IRarHelper,
    {
      code: 'N45',
      description: 'Payment based on authorized amount.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N46',
      description: 'Missing/incomplete/invalid admission hour.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N47',
      description: 'Claim conflicts with another inpatient stay.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N48',
      description:
        'Claim information does not agree with information received from other insurance carrier.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N49',
      description: 'Court ordered coverage information needs validation.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N50',
      description:
        'Missing/incomplete/invalid discharge information.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N51',
      description:
        'Electronic interchange agreement not on file for provider/submitter.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N52',
      description:
        "Patient not enrolled in the billing provider's managed care plan on the date of service.Start: 01/01/2000",
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N53',
      description:
        'Missing/incomplete/invalid point of pick-up address.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N54',
      description:
        'Claim information is inconsistent with pre-certified/authorized services.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N55',
      description:
        'Procedures for billing with group/referring/performing providers were not followed.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N56',
      description:
        'Procedure code billed is not correct/valid for the services billed or the date of service billed.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N57',
      description:
        'Missing/incomplete/invalid prescribing date.Start: 01/01/2000 | Last Modified: 12/02/2004Notes: (Modified 12/2/04) Related to N304',
      dates:
        'Start: 01/01/2000 | Last Modified: 12/02/2004Notes: (Modified 12/2/04) Related to N304'
    } as IRarHelper,
    {
      code: 'N58',
      description:
        'Missing/incomplete/invalid patient liability amount.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N59',
      description:
        'Alert: Please refer to your provider manual for additional program and provider information.Start: 01/01/2000 | Last Modified: 11/01/2015Notes: (Modified 4/1/07, 11/1/09, 11/1/2015)',
      dates:
        'Start: 01/01/2000 | Last Modified: 11/01/2015Notes: (Modified 4/1/07, 11/1/09, 11/1/2015)'
    } as IRarHelper,
    {
      code: 'N60',
      description:
        'A valid NDC is required for payment of drug claims effective October 02.Start: 01/01/2000 | Stop: 01/31/2004Notes: Consider using M119',
      dates: 'Start: 01/01/2000 | Stop: 01/31/2004Notes: Consider using M119'
    } as IRarHelper,
    {
      code: 'N61',
      description: 'Rebill services on separate claims.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N62',
      description:
        'Dates of service span multiple rate periods. Resubmit separate claims.Start: 01/01/2000 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)',
      dates: 'Start: 01/01/2000 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)'
    } as IRarHelper,
    {
      code: 'N63',
      description: 'Rebill services on separate claim lines.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N64',
      description: 'The “from” and “to” dates must be different.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N65',
      description:
        'Procedure code or procedure rate count cannot be determined, or was not on file, for the date of service/provider.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N66',
      description:
        'Missing/incomplete/invalid documentation.Start: 01/01/2000 | Stop: 02/05/2005Notes: Consider using N29 or N225.',
      dates: 'Start: 01/01/2000 | Stop: 02/05/2005Notes: Consider using N29 or N225.'
    } as IRarHelper,
    {
      code: 'N67',
      description:
        'Professional provider services not paid separately.  Included in facility payment under a demonstration project.  Apply to that facility for payment, or resubmit your claim if: the facility notifies you the patient was excluded from this demonstration; or if you furnished these services in another location on the date of the patient’s admission or discharge from a demonstration hospital. If services were furnished in a facility not involved in the demonstration on the same date the patient was discharged from or admitted to a demonstration facility, you must report the provider ID number for the non-demonstration facility on the new claim.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N68',
      description:
        'Prior payment being cancelled as we were subsequently notified this patient was covered by a demonstration project in this site of service.  Professional services were included in the payment made to the facility. You must contact the facility for your payment.  Prior payment made to you by the patient or another insurer for this claim must be refunded to the payer within 30 days.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N69',
      description:
        'Alert: PPS (Prospective Payment System) code changed by claims processing system.Start: 01/01/2000 | Last Modified: 11/01/2015Notes: (Modified 6/30/03, 7/1/12, 11/1/2015)',
      dates:
        'Start: 01/01/2000 | Last Modified: 11/01/2015Notes: (Modified 6/30/03, 7/1/12, 11/1/2015)'
    } as IRarHelper,
    {
      code: 'N70',
      description:
        'Consolidated billing and payment applies.Start: 01/01/2000 | Last Modified: 11/05/2007Notes: (Modified 2/28/02, 11/5/07)',
      dates: 'Start: 01/01/2000 | Last Modified: 11/05/2007Notes: (Modified 2/28/02, 11/5/07)'
    } as IRarHelper,
    {
      code: 'N71',
      description:
        'Your unassigned claim for a drug or biological, clinical diagnostic laboratory services or ambulance service was processed as an assigned claim. You are required by law to accept assignment for these types of claims.Start: 01/01/2000 | Last Modified: 06/30/2003Notes: (Modified 2/21/02, 6/30/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 06/30/2003Notes: (Modified 2/21/02, 6/30/03)'
    } as IRarHelper,
    {
      code: 'N72',
      description:
        'PPS (Prospective Payment System)  code changed by medical reviewers.  Not supported by clinical records.Start: 01/01/2000 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'N73',
      description:
        'A Skilled Nursing Facility is responsible for payment of outside providers who furnish these services/supplies under arrangement to its residents.Start: 01/01/2000 | Stop: 01/31/2004Notes: Consider using MA101 or N200',
      dates: 'Start: 01/01/2000 | Stop: 01/31/2004Notes: Consider using MA101 or N200'
    } as IRarHelper,
    {
      code: 'N74',
      description:
        'Resubmit with multiple claims, each claim covering services provided in only one calendar month.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N75',
      description:
        'Missing/incomplete/invalid tooth surface information.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N76',
      description:
        'Missing/incomplete/invalid number of riders.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N77',
      description:
        'Missing/incomplete/invalid designated provider number.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N78',
      description:
        'The necessary components of the child and teen checkup (EPSDT) were not completed.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N79',
      description:
        'Service billed is not compatible with patient location information.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N80',
      description:
        'Missing/incomplete/invalid prenatal screening information.Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/01/2000 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N81',
      description: 'Procedure billed is not compatible with tooth surface code.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N82',
      description:
        'Provider must accept insurance payment as payment in full when a third party payer contract specifies full reimbursement.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N83',
      description:
        'No appeal rights. Adjudicative decision based on the provisions of a demonstration project.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N84',
      description:
        'Alert: Further installment payments are forthcoming.Start: 01/01/2000 | Last Modified: 04/01/2007Notes: (Modified 4/1/07, 8/1/07)',
      dates: 'Start: 01/01/2000 | Last Modified: 04/01/2007Notes: (Modified 4/1/07, 8/1/07)'
    } as IRarHelper,
    {
      code: 'N85',
      description:
        'Alert: This is the final installment payment.Start: 01/01/2000 | Last Modified: 04/01/2007Notes: (Modified 4/1/07, 8/1/07)',
      dates: 'Start: 01/01/2000 | Last Modified: 04/01/2007Notes: (Modified 4/1/07, 8/1/07)'
    } as IRarHelper,
    {
      code: 'N86',
      description:
        'A failed trial of pelvic muscle exercise training is required in order for biofeedback training for the treatment of urinary incontinence to be covered.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N87',
      description: 'Home use of biofeedback therapy is not covered.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N88',
      description:
        "Alert: This payment is being made conditionally.  An HHA episode of care notice has been filed for this patient. When a patient is treated under a HHA episode of care, consolidated billing requires that certain therapy services and supplies, such as this, be included in the HHA's payment.  This payment will need to be recouped from you if we establish that the patient is concurrently receiving treatment under a HHA episode of care.Start: 01/01/2000 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)",
      dates: 'Start: 01/01/2000 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N89',
      description:
        'Alert: Payment information for this claim has been forwarded to more than one other payer, but format limitations permit only one of the secondary payers to be identified in this remittance advice.Start: 01/01/2000 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 01/01/2000 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N90',
      description: 'Covered only when performed by the attending physician.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N91',
      description: 'Services not included in the appeal review.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N92',
      description: 'This facility is not certified for digital mammography.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N93',
      description:
        'A separate claim must be submitted for each place of service. Services furnished at multiple sites may not be billed in the same claim.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N94',
      description:
        'Claim/Service denied because a more specific taxonomy code is required for adjudication.Start: 01/01/2000',
      dates: 'Start: 01/01/2000'
    } as IRarHelper,
    {
      code: 'N95',
      description:
        'This provider type/provider specialty may not bill this service.Start: 07/31/2001 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 07/31/2001 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N96',
      description:
        'Patient must be refractory to conventional therapy (documented behavioral, pharmacologic and/or surgical corrective therapy) and be an appropriate surgical candidate such that implantation with anesthesia can occur.Start: 08/24/2001',
      dates: 'Start: 08/24/2001'
    } as IRarHelper,
    {
      code: 'N97',
      description:
        'Patients with stress incontinence, urinary obstruction, and specific neurologic diseases (e.g., diabetes with peripheral nerve involvement) which are associated with secondary manifestations of the above three indications are excluded.Start: 08/24/2001',
      dates: 'Start: 08/24/2001'
    } as IRarHelper,
    {
      code: 'N98',
      description:
        'Patient must have had a successful test stimulation in order to support subsequent implantation. Before a patient is eligible for permanent implantation, he/she must demonstrate a 50 percent or greater improvement through test stimulation. Improvement is measured through voiding diaries.Start: 08/24/2001',
      dates: 'Start: 08/24/2001'
    } as IRarHelper,
    {
      code: 'N99',
      description:
        'Patient must be able to demonstrate adequate ability to record voiding diary data such that clinical results of the implant procedure can be properly evaluated.Start: 08/24/2001',
      dates: 'Start: 08/24/2001'
    } as IRarHelper,
    {
      code: 'N100',
      description:
        'PPS (Prospect Payment System) code corrected during adjudication.Start: 09/14/2001 | Stop: 11/01/2016 | Last Modified: 11/01/2015Notes: (Modified 6/30/03, 11/1/2015)',
      dates:
        'Start: 09/14/2001 | Stop: 11/01/2016 | Last Modified: 11/01/2015Notes: (Modified 6/30/03, 11/1/2015)'
    } as IRarHelper,
    {
      code: 'N101',
      description:
        "Additional information is needed in order to process this claim. Please resubmit the claim with the identification number of the provider where this service took place. The Medicare number of the site of service provider should be preceded with the letters 'HSP' and entered into item #32 on the claim form. You may bill only one site of service provider number per claim.Start: 10/31/2001 | Stop: 01/31/2004 | Last Modified: 03/14/2014Notes: Consider using MA105 (Modified 3/14/2014)",
      dates:
        'Start: 10/31/2001 | Stop: 01/31/2004 | Last Modified: 03/14/2014Notes: Consider using MA105 (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N102',
      description:
        'This claim has been denied without reviewing the medical/dental record because the requested records were not received or were not received timely.Start: 10/31/2001 | Stop: 07/01/2016 | Last Modified: 11/01/2013',
      dates: 'Start: 10/31/2001 | Stop: 07/01/2016 | Last Modified: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N103',
      description:
        'Records indicate this patient was a prisoner or in custody of a Federal, State, or local authority when the service was rendered. This  payer does not cover items and services furnished to an individual while he or she is in custody under a penal statute or rule, unless under State or local law, the individual is personally liable for the cost of his or her health care while in custody and the State or local government pursues the collection of such debt in the same way and with the same vigor as the collection of its other debts. The provider can collect from the Federal/State/ Local Authority as appropriate.Start: 10/31/2001 | Last Modified: 11/01/2013Notes: (Modified 6/30/03, 7/1/12, 11/1/13)',
      dates:
        'Start: 10/31/2001 | Last Modified: 11/01/2013Notes: (Modified 6/30/03, 7/1/12, 11/1/13)'
    } as IRarHelper,
    {
      code: 'N104',
      description:
        'This claim/service is not payable under our claims jurisdiction area. You can identify the correct Medicare contractor to process this claim/service through the CMS website at www.cms.gov.Start: 01/29/2002 | Last Modified: 07/01/2010Notes: (Modified 10/31/02, 7/1/10)',
      dates: 'Start: 01/29/2002 | Last Modified: 07/01/2010Notes: (Modified 10/31/02, 7/1/10)'
    } as IRarHelper,
    {
      code: 'N105',
      description:
        'This is a misdirected claim/service for an RRB beneficiary. Submit paper claims to the RRB carrier: Palmetto GBA, P.O. Box 10066, Augusta, GA 30999. Call 888-355-9165 for RRB EDI information for electronic claims processing.Start: 01/29/2002 | Last Modified: 07/01/2017Notes: (Modified 7/1/2017)',
      dates: 'Start: 01/29/2002 | Last Modified: 07/01/2017Notes: (Modified 7/1/2017)'
    } as IRarHelper,
    {
      code: 'N106',
      description:
        'Payment for services furnished to Skilled Nursing Facility (SNF) inpatients (except for excluded services) can only be made to the SNF. You must request payment from the SNF rather than the patient for this service.Start: 01/31/2002',
      dates: 'Start: 01/31/2002'
    } as IRarHelper,
    {
      code: 'N107',
      description:
        'Services furnished to Skilled Nursing Facility (SNF) inpatients must be billed on the inpatient claim. They cannot be billed separately as outpatient services.Start: 01/31/2002',
      dates: 'Start: 01/31/2002'
    } as IRarHelper,
    {
      code: 'N108',
      description:
        'Missing/incomplete/invalid upgrade information.Start: 01/31/2002 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)',
      dates: 'Start: 01/31/2002 | Last Modified: 02/28/2003Notes: (Modified 2/28/03)'
    } as IRarHelper,
    {
      code: 'N109',
      description:
        'Alert: This claim/service was chosen for complex review.Start: 02/28/2002 | Last Modified: 07/01/2015Notes: (Modified 3/1/2009, 7/1/15)',
      dates: 'Start: 02/28/2002 | Last Modified: 07/01/2015Notes: (Modified 3/1/2009, 7/1/15)'
    } as IRarHelper,
    {
      code: 'N110',
      description: 'This facility is not certified for film mammography.Start: 02/28/2002',
      dates: 'Start: 02/28/2002'
    } as IRarHelper,
    {
      code: 'N111',
      description:
        'No appeal right except duplicate claim/service issue. This service was included in a claim that has been previously billed and adjudicated.Start: 02/28/2002',
      dates: 'Start: 02/28/2002'
    } as IRarHelper,
    {
      code: 'N112',
      description:
        'This claim is excluded from your electronic remittance advice.Start: 02/28/2002',
      dates: 'Start: 02/28/2002'
    } as IRarHelper,
    {
      code: 'N113',
      description:
        'Only one initial visit is covered per physician, group practice or provider.Start: 04/16/2002 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 04/16/2002 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'N114',
      description:
        'During the transition to the Ambulance Fee Schedule, payment is based on the lesser of a blended amount calculated using a percentage of the reasonable charge/cost and fee schedule amounts, or the submitted charge for the service.  You will be notified yearly what the percentages for the blended payment calculation will be.Start: 05/30/2002',
      dates: 'Start: 05/30/2002'
    } as IRarHelper,
    {
      code: 'N115',
      description:
        'This decision was based on a Local Coverage Determination (LCD).  An LCD provides a guide to assist in determining whether a particular item or service is covered. A copy of this policy is available at www.cms.gov/mcd, or if you do not have web access, you may contact the contractor to request a copy of the LCD.Start: 05/30/2002 | Last Modified: 07/01/2010Notes: (Modified 4/1/04, 7/1/10)',
      dates: 'Start: 05/30/2002 | Last Modified: 07/01/2010Notes: (Modified 4/1/04, 7/1/10)'
    } as IRarHelper,
    {
      code: 'N116',
      description:
        'Alert: This payment is being made conditionally because the service was provided in the home, and it is possible that the patient is under a home health episode of care. When a patient is treated under a home health episode of care, consolidated billing requires that certain therapy services and supplies, such as this, be included in the home health agency’s (HHA’s) payment. This payment will need to be recouped from you if we establish that the patient is concurrently receiving treatment under an HHA episode of care.Start: 06/30/2002 | Last Modified: 11/01/2016Notes: (Modified 11/1/2016)',
      dates: 'Start: 06/30/2002 | Last Modified: 11/01/2016Notes: (Modified 11/1/2016)'
    } as IRarHelper,
    {
      code: 'N117',
      description:
        'This service is paid only once in a patient’s lifetime.Start: 07/30/2002 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 07/30/2002 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'N118',
      description:
        'This service is not paid if billed more than once every 28 days.Start: 07/30/2002',
      dates: 'Start: 07/30/2002'
    } as IRarHelper,
    {
      code: 'N119',
      description:
        'This service is not paid if billed once every 28 days, and the patient has spent 5 or more consecutive days in any inpatient or Skilled /nursing Facility (SNF) within those 28 days.Start: 07/30/2002 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 07/30/2002 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'N120',
      description:
        'Payment is subject to home health prospective payment system partial episode payment adjustment. Patient was transferred/discharged/readmitted during payment episode.Start: 08/09/2002 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)',
      dates: 'Start: 08/09/2002 | Last Modified: 06/30/2003Notes: (Modified 6/30/03)'
    } as IRarHelper,
    {
      code: 'N121',
      description:
        'Medicare Part B does not pay for items or services provided by this type of practitioner for beneficiaries in a Medicare Part A covered Skilled Nursing Facility (SNF) stay.Start: 09/09/2002 | Last Modified: 08/01/2004Notes: (Modified 8/1/04, 6/30/03)',
      dates: 'Start: 09/09/2002 | Last Modified: 08/01/2004Notes: (Modified 8/1/04, 6/30/03)'
    } as IRarHelper,
    {
      code: 'N122',
      description:
        'Add-on code cannot be billed by itself.Start: 09/12/2002 | Last Modified: 08/01/2005Notes: (Modified 8/1/05)',
      dates: 'Start: 09/12/2002 | Last Modified: 08/01/2005Notes: (Modified 8/1/05)'
    } as IRarHelper,
    {
      code: 'N123',
      description:
        'Alert: This is a split service and represents a portion of the units from the originally submitted service.Start: 09/24/2002 | Last Modified: 03/01/2016Notes: (Modified 3/1/2016)',
      dates: 'Start: 09/24/2002 | Last Modified: 03/01/2016Notes: (Modified 3/1/2016)'
    } as IRarHelper,
    {
      code: 'N124',
      description:
        'Payment has been denied for the/made only for a less extensive service/item because the information furnished does not substantiate the need for the (more extensive) service/item. The patient is liable for the charges for this service/item as you informed the patient in writing before the service/item was furnished that we would not pay for it, and the patient agreed to pay.Start: 09/26/2002',
      dates: 'Start: 09/26/2002'
    } as IRarHelper,
    {
      code: 'N125',
      description:
        'Payment has been (denied for the/made only for a less extensive) service/item because the information furnished does not substantiate the need for the (more extensive) service/item. If you have collected any amount from the patient, you must refund that amount to the patient within 30 days of receiving this notice.The requirements for a refund are in §1834(a)(18) of the Social Security Act (and in §§1834(j)(4) and 1879(h) by cross-reference to §1834(a)(18)). Section 1834(a)(18)(B) specifies that suppliers which knowingly and willfully fail to make appropriate refunds may be subject to civil money penalties and/or exclusion from the Medicare program. If you have any questions about this notice, please contact this office.Start: 09/26/2002 | Last Modified: 08/01/2005Notes: (Modified 8/1/05. Also refer to N356)',
      dates:
        'Start: 09/26/2002 | Last Modified: 08/01/2005Notes: (Modified 8/1/05. Also refer to N356)'
    } as IRarHelper,
    {
      code: 'N126',
      description:
        'Social Security Records indicate that this individual has been deported. This payer does not cover items and services furnished to individuals who have been deported.Start: 10/17/2002',
      dates: 'Start: 10/17/2002'
    } as IRarHelper,
    {
      code: 'N127',
      description:
        'This is a misdirected claim/service for a United Mine Workers of America (UMWA) beneficiary. Please submit claims to them.Start: 10/31/2007 | Last Modified: 08/01/2004Notes: (Modified 8/1/04',
      dates: 'Start: 10/31/2007 | Last Modified: 08/01/2004Notes: (Modified 8/1/04'
    } as IRarHelper,
    {
      code: 'N128',
      description:
        'This amount represents the prior to coverage portion of the allowance.Start: 10/31/2002',
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N129',
      description:
        "Not eligible due to the patient's age.Start: 10/31/2002 | Last Modified: 08/01/2007Notes: (Modified 8/1/07)",
      dates: 'Start: 10/31/2002 | Last Modified: 08/01/2007Notes: (Modified 8/1/07)'
    } as IRarHelper,
    {
      code: 'N130',
      description:
        'Consult plan benefit documents/guidelines for information about restrictions for this service.Start: 10/31/2002 | Last Modified: 11/01/2009Notes: (Modified 4/1/07, 7/1/08, 11/1/09)',
      dates:
        'Start: 10/31/2002 | Last Modified: 11/01/2009Notes: (Modified 4/1/07, 7/1/08, 11/1/09)'
    } as IRarHelper,
    {
      code: 'N131',
      description:
        'Total payments under multiple contracts cannot exceed the allowance for this service.Start: 10/31/2002',
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N132',
      description:
        'Alert: Payments will cease for services rendered by this US Government debarred or excluded provider after the 30 day grace period as previously notified.Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N133',
      description:
        'Alert: Services for predetermination and services requesting payment are being processed separately.Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N134',
      description:
        'Alert: This represents your scheduled payment for this service. If treatment has been discontinued, please contact Customer Service.Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N135',
      description:
        "Record fees are the patient's responsibility and limited to the specified co-payment.Start: 10/31/2002",
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N136',
      description:
        "Alert: To obtain information on the process to file an appeal in Arizona, call the Department's Consumer Assistance Office at (602) 912-8444 or (800) 325-2548.Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)",
      dates: 'Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N137',
      description:
        "Alert: The provider acting on the Member's behalf, may file an appeal with the Payer. The provider, acting on the Member's behalf, may file a complaint with the State Insurance Regulatory Authority without first filing an appeal, if the coverage decision involves an urgent condition for which care has not been rendered. The address may be obtained from the State Insurance Regulatory Authority.Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified  8/1/04, 2/28/03, 4/1/07)",
      dates:
        'Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified  8/1/04, 2/28/03, 4/1/07)'
    } as IRarHelper,
    {
      code: 'N138',
      description:
        "Alert: In the event you disagree with the Dental Advisor's opinion and have additional information relative to the case, you may submit radiographs to the Dental Advisor Unit at the subscriber's dental insurance carrier for a second Independent Dental Advisor Review.Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)",
      dates: 'Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N139',
      description:
        "Alert: Under 32 CFR 199.13, a non-participating provider is not an appropriate appealing party. Therefore, if you disagree with the Dental Advisor's opinion, you may appeal the determination if appointed in writing, by the beneficiary, to act as his/her representative. Should you be appointed as a representative, submit a copy of this letter, a signed statement explaining the matter in which you disagree, and any radiographs and relevant information to the subscriber's Dental insurance carrier within 90 days from the date of this letter.Start: 10/31/2002 | Last Modified: 03/01/2017Notes: (Modified 4/1/07, 3/1/2017)",
      dates: 'Start: 10/31/2002 | Last Modified: 03/01/2017Notes: (Modified 4/1/07, 3/1/2017)'
    } as IRarHelper,
    {
      code: 'N140',
      description:
        "Alert: You have not been designated as an authorized OCONUS provider therefore are not considered an appropriate appealing party. If the beneficiary has appointed you, in writing, to act as his/her representative and you disagree with the Dental Advisor's opinion, you may appeal by submitting a copy of this letter, a signed statement explaining the matter in which you disagree, and any relevant information to the subscriber's Dental insurance carrier within 90 days from the date of this letter.Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)",
      dates: 'Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N141',
      description:
        'The patient was not residing in a long-term care facility during all or part of the service dates billed.Start: 10/31/2002',
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N142',
      description:
        'The original claim was denied.  Resubmit a new claim, not a replacement claim.Start: 10/31/2002',
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N143',
      description:
        'The patient was not in a hospice program during all or part of the service dates billed.Start: 10/31/2002',
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N144',
      description: 'The rate changed during the dates of service billed.Start: 10/31/2002',
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N145',
      description:
        'Missing/incomplete/invalid provider identifier for this place of service.Start: 10/31/2002 | Stop: 06/02/2005',
      dates: 'Start: 10/31/2002 | Stop: 06/02/2005'
    } as IRarHelper,
    {
      code: 'N146',
      description:
        'Missing screening document.Start: 10/31/2002 | Last Modified: 08/01/2004Notes: (Modified  8/1/04) Related to N243',
      dates:
        'Start: 10/31/2002 | Last Modified: 08/01/2004Notes: (Modified  8/1/04) Related to N243'
    } as IRarHelper,
    {
      code: 'N147',
      description:
        'Long term care case mix or per diem rate cannot be determined because the patient ID number is missing, incomplete, or invalid on the assignment request.Start: 10/31/2002',
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N148',
      description: 'Missing/incomplete/invalid date of last menstrual period.Start: 10/31/2002',
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N149',
      description: 'Rebill all applicable services on a single claim.Start: 10/31/2002',
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N150',
      description: 'Missing/incomplete/invalid model number.Start: 10/31/2002',
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N151',
      description:
        'Telephone contact services will not be paid until the face-to-face contact requirement has been met.Start: 10/31/2002',
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N152',
      description: 'Missing/incomplete/invalid replacement claim information.Start: 10/31/2002',
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N153',
      description: 'Missing/incomplete/invalid room and board rate.Start: 10/31/2002',
      dates: 'Start: 10/31/2002'
    } as IRarHelper,
    {
      code: 'N154',
      description:
        "Alert: This payment was delayed for correction of provider's mailing address.Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)",
      dates: 'Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N155',
      description:
        'Alert: Our records do not indicate that other insurance is on file.  Please submit other insurance information for our records.Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N156',
      description:
        'Alert: The patient is responsible for the difference between the approved treatment and the elective treatment.Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 10/31/2002 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N157',
      description:
        'Transportation to/from this destination is not covered.Start: 02/28/2003 | Last Modified: 02/01/2004Notes: (Modified 2/1/04)',
      dates: 'Start: 02/28/2003 | Last Modified: 02/01/2004Notes: (Modified 2/1/04)'
    } as IRarHelper,
    {
      code: 'N158',
      description:
        'Transportation in a vehicle other than an ambulance is not covered.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N159',
      description:
        'Payment denied/reduced because mileage is not covered when the patient is not in the ambulance.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N160',
      description:
        'The patient must choose an option before a payment can be made for this procedure/ equipment/ supply/ service.Start: 02/28/2003 | Last Modified: 02/01/2004Notes: (Modified 2/1/04)',
      dates: 'Start: 02/28/2003 | Last Modified: 02/01/2004Notes: (Modified 2/1/04)'
    } as IRarHelper,
    {
      code: 'N161',
      description:
        'This drug/service/supply is covered only when the associated service is covered.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N162',
      description:
        'Alert: Although your claim was paid, you have billed for a test/specialty not included in your Laboratory Certification.  Your failure to correct the laboratory certification information will result in a denial of payment in the near future.Start: 02/28/2003 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 02/28/2003 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N163',
      description:
        'Medical record does not support code billed per the code definition.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N164',
      description:
        'Transportation to/from this destination is not covered.Start: 02/28/2003 | Stop: 01/31/2004Notes: Consider using N157',
      dates: 'Start: 02/28/2003 | Stop: 01/31/2004Notes: Consider using N157'
    } as IRarHelper,
    {
      code: 'N165',
      description:
        'Transportation in a vehicle other than an ambulance is not covered.Start: 02/28/2003 | Stop: 01/31/2004Notes: Consider using N158)',
      dates: 'Start: 02/28/2003 | Stop: 01/31/2004Notes: Consider using N158)'
    } as IRarHelper,
    {
      code: 'N166',
      description:
        'Payment denied/reduced because mileage is not covered when the patient is not in the ambulance.Start: 02/28/2003 | Stop: 01/31/2004Notes: Consider using N159',
      dates: 'Start: 02/28/2003 | Stop: 01/31/2004Notes: Consider using N159'
    } as IRarHelper,
    {
      code: 'N167',
      description: 'Charges exceed the post-transplant coverage limit.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N168',
      description:
        'The patient must choose an option before a payment can be made for this procedure/ equipment/ supply/ service.Start: 02/28/2003 | Stop: 01/31/2004Notes: Consider using N160',
      dates: 'Start: 02/28/2003 | Stop: 01/31/2004Notes: Consider using N160'
    } as IRarHelper,
    {
      code: 'N169',
      description:
        'This drug/service/supply is covered only when the associated service is covered.Start: 02/28/2003 | Stop: 01/31/2004Notes: Consider using N161',
      dates: 'Start: 02/28/2003 | Stop: 01/31/2004Notes: Consider using N161'
    } as IRarHelper,
    {
      code: 'N170',
      description:
        'A new/revised/renewed certificate of medical necessity is needed.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N171',
      description:
        'Payment for repair or replacement is not covered or has exceeded the purchase price.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N172',
      description:
        'The patient is not liable for the denied/adjusted charge(s) for receiving any updated service/item.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N173',
      description:
        'No qualifying hospital stay dates were provided for this episode of care.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N174',
      description:
        "This is not a covered service/procedure/ equipment/bed, however patient liability is limited to amounts shown in the adjustments under group 'PR'.Start: 02/28/2003",
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N175',
      description:
        'Missing review organization approval.Start: 02/28/2003 | Last Modified: 02/29/2008Notes: (Modified 8/1/04, 2/29/08) Related to N241',
      dates:
        'Start: 02/28/2003 | Last Modified: 02/29/2008Notes: (Modified 8/1/04, 2/29/08) Related to N241'
    } as IRarHelper,
    {
      code: 'N176',
      description:
        'Services provided aboard a ship are covered only when the ship is of United States registry and is in United States waters. In addition, a doctor licensed to practice in the United States must provide the service.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N177',
      description:
        'Alert: We did not send this claim to patient’s other insurer. They have indicated no additional payment can be made.Start: 02/28/2003 | Last Modified: 04/01/2007Notes: (Modified 6/30/03, 4/1/07)',
      dates: 'Start: 02/28/2003 | Last Modified: 04/01/2007Notes: (Modified 6/30/03, 4/1/07)'
    } as IRarHelper,
    {
      code: 'N178',
      description:
        'Missing pre-operative images/visual field results.Start: 02/28/2003 | Last Modified: 11/01/2013Notes: (Modified 8/1/04, 11/1/13) Related to N244',
      dates:
        'Start: 02/28/2003 | Last Modified: 11/01/2013Notes: (Modified 8/1/04, 11/1/13) Related to N244'
    } as IRarHelper,
    {
      code: 'N179',
      description:
        'Additional information has been requested from the member.  The charges will be reconsidered upon receipt of that information.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N180',
      description:
        'This item or service does not meet the criteria for the category under which it was billed.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N181',
      description:
        'Additional information is required from another provider involved in this service.Start: 02/28/2003 | Last Modified: 12/01/2006Notes: (Modified 12/1/06)',
      dates: 'Start: 02/28/2003 | Last Modified: 12/01/2006Notes: (Modified 12/1/06)'
    } as IRarHelper,
    {
      code: 'N182',
      description:
        'This claim/service must be billed according to the schedule for this plan.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N183',
      description:
        'Alert: This is a predetermination advisory message, when this service is submitted for payment additional documentation as specified in plan documents will be required to process benefits.Start: 02/28/2003 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 02/28/2003 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N184',
      description: 'Rebill technical and professional components separately.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N185',
      description:
        'Alert: Do not resubmit this claim/service.Start: 02/28/2003 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 02/28/2003 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N186',
      description:
        'Non-Availability Statement (NAS) required for this service. Contact the nearest Military Treatment Facility (MTF) for assistance.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N187',
      description:
        'Alert: You may request a review in writing within the required time limits following receipt of this notice by following the instructions included in your contract or plan benefit documents.Start: 02/28/2003 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 02/28/2003 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N188',
      description:
        'The approved level of care does not match the procedure code submitted.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N189',
      description:
        "Alert: This service has been paid as a one-time exception to the plan's benefit restrictions.Start: 02/28/2003 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)",
      dates: 'Start: 02/28/2003 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N190',
      description:
        'Missing contract indicator.Start: 02/28/2003 | Last Modified: 08/01/2004Notes: (Modified 8/1/04) Related to N229',
      dates: 'Start: 02/28/2003 | Last Modified: 08/01/2004Notes: (Modified 8/1/04) Related to N229'
    } as IRarHelper,
    {
      code: 'N191',
      description:
        'The provider must update insurance information directly with payer.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N192',
      description: 'Patient is a Medicaid/Qualified Medicare Beneficiary.Start: 02/28/2003',
      dates: 'Start: 02/28/2003'
    } as IRarHelper,
    {
      code: 'N193',
      description:
        'Alert: Specific federal/state/local program may cover this service through another payer.Start: 02/28/2003 | Last Modified: 11/01/2015Notes: (Modified 11/1/2015)',
      dates: 'Start: 02/28/2003 | Last Modified: 11/01/2015Notes: (Modified 11/1/2015)'
    } as IRarHelper,
    {
      code: 'N194',
      description:
        'Technical component not paid if provider does not own the equipment used.Start: 02/25/2003',
      dates: 'Start: 02/25/2003'
    } as IRarHelper,
    {
      code: 'N195',
      description: 'The technical component must be billed separately.Start: 02/25/2003',
      dates: 'Start: 02/25/2003'
    } as IRarHelper,
    {
      code: 'N196',
      description:
        'Alert: Patient eligible to apply for other coverage which may be primary.Start: 02/25/2003 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 02/25/2003 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N197',
      description:
        'The subscriber must update insurance information directly with payer.Start: 02/25/2003',
      dates: 'Start: 02/25/2003'
    } as IRarHelper,
    {
      code: 'N198',
      description:
        'Rendering provider must be affiliated with the pay-to provider.Start: 02/25/2003',
      dates: 'Start: 02/25/2003'
    } as IRarHelper,
    {
      code: 'N199',
      description:
        'Additional payment/recoupment approved based on payer-initiated review/audit.Start: 02/25/2003 | Last Modified: 08/01/2006Notes: (Modified 8/1/06)',
      dates: 'Start: 02/25/2003 | Last Modified: 08/01/2006Notes: (Modified 8/1/06)'
    } as IRarHelper,
    {
      code: 'N200',
      description: 'The professional component must be billed separately.Start: 02/25/2003',
      dates: 'Start: 02/25/2003'
    } as IRarHelper,
    {
      code: 'N201',
      description:
        'A mental health facility is responsible for payment of outside providers who furnish these services/supplies to residents.Start: 02/25/2003 | Stop: 01/01/2011Notes: Consider using N538',
      dates: 'Start: 02/25/2003 | Stop: 01/01/2011Notes: Consider using N538'
    } as IRarHelper,
    {
      code: 'N202',
      description:
        'Alert: Additional information/explanation will be sent separately.Start: 06/30/2003 | Last Modified: 11/01/2015Notes: (Modified 4/1/07, 11/1/09, 3/14/2014, 11/1/2015)',
      dates:
        'Start: 06/30/2003 | Last Modified: 11/01/2015Notes: (Modified 4/1/07, 11/1/09, 3/14/2014, 11/1/2015)'
    } as IRarHelper,
    {
      code: 'N203',
      description:
        'Missing/incomplete/invalid anesthesia time/units.Start: 06/30/2003 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 06/30/2003 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N204',
      description:
        'Services under review for possible pre-existing condition. Send medical records for prior 12 monthsStart: 06/30/2003',
      dates: 'Start: 06/30/2003'
    } as IRarHelper,
    {
      code: 'N205',
      description:
        'Information provided was illegible.Start: 06/30/2003 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 06/30/2003 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N206',
      description:
        'The supporting documentation does not match the information sent on the claim.Start: 06/30/2003 | Last Modified: 03/06/2012Notes: (Modified 3/6/12)',
      dates: 'Start: 06/30/2003 | Last Modified: 03/06/2012Notes: (Modified 3/6/12)'
    } as IRarHelper,
    {
      code: 'N207',
      description:
        'Missing/incomplete/invalid weight.Start: 06/30/2003 | Last Modified: 11/18/2005Notes: (Modified 11/18/05)',
      dates: 'Start: 06/30/2003 | Last Modified: 11/18/2005Notes: (Modified 11/18/05)'
    } as IRarHelper,
    {
      code: 'N208',
      description:
        'Missing/incomplete/invalid DRG code.Start: 06/30/2003 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 06/30/2003 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N209',
      description:
        'Missing/incomplete/invalid taxpayer identification number (TIN).Start: 06/30/2003 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)',
      dates: 'Start: 06/30/2003 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)'
    } as IRarHelper,
    {
      code: 'N210',
      description:
        'Alert: You may appeal this decision.Start: 06/30/2003 | Last Modified: 03/14/2014Notes: (Modified 4/1/07, 3/14/2014)',
      dates: 'Start: 06/30/2003 | Last Modified: 03/14/2014Notes: (Modified 4/1/07, 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N211',
      description:
        'Alert: You may not appeal this decision.Start: 06/30/2003 | Last Modified: 03/14/2014Notes: (Modified 4/1/07, 3/14/2014)',
      dates: 'Start: 06/30/2003 | Last Modified: 03/14/2014Notes: (Modified 4/1/07, 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N212',
      description:
        'Charges processed under a Point of Service benefit .Start: 02/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 02/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N213',
      description:
        'Missing/incomplete/invalid facility/discrete unit DRG/DRG exempt status information.Start: 04/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 04/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N214',
      description:
        'Missing/incomplete/invalid history of the related initial surgical procedure(s).Start: 04/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 04/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N215',
      description:
        'Alert: A payer providing supplemental or secondary coverage shall not require a claims determination for this service from a primary payer as a condition of making its own claims determination.Start: 04/01/2004 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 04/01/2004 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N216',
      description:
        'We do not offer coverage for this type of service or the patient is not enrolled in this portion of our benefit package.Start: 04/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/1/2010, 3/14/2014)',
      dates: 'Start: 04/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/1/2010, 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N217',
      description:
        'We pay only one site of service per provider per claim.Start: 08/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 08/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N218',
      description:
        'You must furnish and service this item for as long as the patient continues to need it.  We can pay for maintenance and/or servicing for the time period specified in the contract or coverage manual.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N219',
      description: "Payment based on previous payer's allowed amount.Start: 08/01/2004",
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N220',
      description:
        "Alert: See the payer's web site or contact the payer's Customer Service department to obtain forms and instructions for filing a provider dispute.Start: 08/01/2004 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)",
      dates: 'Start: 08/01/2004 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N221',
      description: 'Missing Admitting History and Physical report.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N222',
      description: 'Incomplete/invalid Admitting History and Physical report.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N223',
      description:
        'Missing documentation of benefit to the patient during initial treatment period.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N224',
      description:
        'Incomplete/invalid documentation of benefit to the patient during initial treatment period.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N225',
      description:
        'Incomplete/invalid documentation/orders/notes/summary/report/chart.Start: 08/01/2004 | Stop: 03/01/2016 | Last Modified: 03/01/2014Notes: (Modified 8/1/05, 3/1/2014) Explicit RARCs have been approved, this non-specific RARC will be deactivated in March 2016.',
      dates:
        'Start: 08/01/2004 | Stop: 03/01/2016 | Last Modified: 03/01/2014Notes: (Modified 8/1/05, 3/1/2014) Explicit RARCs have been approved, this non-specific RARC will be deactivated in March 2016.'
    } as IRarHelper,
    {
      code: 'N226',
      description:
        'Incomplete/invalid American Diabetes Association Certificate of Recognition.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N227',
      description: 'Incomplete/invalid Certificate of Medical Necessity.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N228',
      description: 'Incomplete/invalid consent form.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N229',
      description: 'Incomplete/invalid contract indicator.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N230',
      description:
        'Incomplete/invalid indication of whether the patient owns the equipment that requires the part or supply.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N231',
      description:
        'Incomplete/invalid invoice or statement certifying the actual cost of the lens, less discounts, and/or the type of intraocular lens used.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N232',
      description:
        'Incomplete/invalid itemized bill/statement.Start: 08/01/2004 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)',
      dates: 'Start: 08/01/2004 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)'
    } as IRarHelper,
    {
      code: 'N233',
      description:
        'Incomplete/invalid operative note/report.Start: 08/01/2004 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)',
      dates: 'Start: 08/01/2004 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)'
    } as IRarHelper,
    {
      code: 'N234',
      description: 'Incomplete/invalid oxygen certification/re-certification.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N235',
      description: 'Incomplete/invalid pacemaker registration form.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N236',
      description: 'Incomplete/invalid pathology report.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N237',
      description: 'Incomplete/invalid patient medical record for this service.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N238',
      description:
        'Incomplete/invalid physician certified plan of care.Start: 08/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 08/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N239',
      description: 'Incomplete/invalid physician financial relationship form.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N240',
      description: 'Incomplete/invalid radiology report.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N241',
      description:
        'Incomplete/invalid review organization approval.Start: 08/01/2004 | Last Modified: 02/29/2008Notes: (Modified 2/29/08)',
      dates: 'Start: 08/01/2004 | Last Modified: 02/29/2008Notes: (Modified 2/29/08)'
    } as IRarHelper,
    {
      code: 'N242',
      description:
        'Incomplete/invalid radiology film(s)/image(s).Start: 08/01/2004 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)',
      dates: 'Start: 08/01/2004 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)'
    } as IRarHelper,
    {
      code: 'N243',
      description: 'Incomplete/invalid/not approved screening document.Start: 08/01/2004',
      dates: 'Start: 08/01/2004'
    } as IRarHelper,
    {
      code: 'N244',
      description:
        'Incomplete/Invalid pre-operative  images/visual field results.Start: 08/01/2004 | Last Modified: 11/01/2013Notes: (Modified 11/1/2013)',
      dates: 'Start: 08/01/2004 | Last Modified: 11/01/2013Notes: (Modified 11/1/2013)'
    } as IRarHelper,
    {
      code: 'N245',
      description:
        'Incomplete/invalid plan information for other insurance .Start: 08/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 08/01/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N246',
      description:
        'State regulated patient payment limitations apply to this service.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N247',
      description: 'Missing/incomplete/invalid assistant surgeon taxonomy.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N248',
      description: 'Missing/incomplete/invalid assistant surgeon name.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N249',
      description:
        'Missing/incomplete/invalid assistant surgeon primary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N250',
      description:
        'Missing/incomplete/invalid assistant surgeon secondary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N251',
      description: 'Missing/incomplete/invalid attending provider taxonomy.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N252',
      description: 'Missing/incomplete/invalid attending provider name.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N253',
      description:
        'Missing/incomplete/invalid attending provider primary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N254',
      description:
        'Missing/incomplete/invalid attending provider secondary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N255',
      description: 'Missing/incomplete/invalid billing provider taxonomy.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N256',
      description: 'Missing/incomplete/invalid billing provider/supplier name.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N257',
      description:
        'Missing/incomplete/invalid billing provider/supplier primary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N258',
      description: 'Missing/incomplete/invalid billing provider/supplier address.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N259',
      description:
        'Missing/incomplete/invalid billing provider/supplier secondary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N260',
      description:
        'Missing/incomplete/invalid billing provider/supplier contact information.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N261',
      description: 'Missing/incomplete/invalid operating provider name.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N262',
      description:
        'Missing/incomplete/invalid operating provider primary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N263',
      description:
        'Missing/incomplete/invalid operating provider secondary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N264',
      description: 'Missing/incomplete/invalid ordering provider name.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N265',
      description:
        'Missing/incomplete/invalid ordering provider primary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N266',
      description: 'Missing/incomplete/invalid ordering provider address.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N267',
      description:
        'Missing/incomplete/invalid ordering provider secondary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N268',
      description:
        'Missing/incomplete/invalid ordering provider contact information.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N269',
      description: 'Missing/incomplete/invalid other provider name.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N270',
      description: 'Missing/incomplete/invalid other provider primary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N271',
      description:
        'Missing/incomplete/invalid other provider secondary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N272',
      description:
        'Missing/incomplete/invalid other payer attending provider identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N273',
      description:
        'Missing/incomplete/invalid other payer operating provider identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N274',
      description:
        'Missing/incomplete/invalid other payer other provider identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N275',
      description:
        'Missing/incomplete/invalid other payer purchased service provider identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N276',
      description:
        'Missing/incomplete/invalid other payer referring provider identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N277',
      description:
        'Missing/incomplete/invalid other payer rendering provider identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N278',
      description:
        'Missing/incomplete/invalid other payer service facility provider identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N279',
      description: 'Missing/incomplete/invalid pay-to provider name.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N280',
      description:
        'Missing/incomplete/invalid pay-to provider primary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N281',
      description: 'Missing/incomplete/invalid pay-to provider address.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N282',
      description:
        'Missing/incomplete/invalid pay-to provider secondary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N283',
      description:
        'Missing/incomplete/invalid purchased service provider identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N284',
      description: 'Missing/incomplete/invalid referring provider taxonomy.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N285',
      description: 'Missing/incomplete/invalid referring provider name.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N286',
      description:
        'Missing/incomplete/invalid referring provider primary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N287',
      description:
        'Missing/incomplete/invalid referring provider secondary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N288',
      description: 'Missing/incomplete/invalid rendering provider taxonomy.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N289',
      description: 'Missing/incomplete/invalid rendering provider name.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N290',
      description:
        'Missing/incomplete/invalid rendering provider primary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N291',
      description:
        'Missing/incomplete/invalid rendering provider secondary identifier.Start: 12/02/2004 | Last Modified: 11/01/2010',
      dates: 'Start: 12/02/2004 | Last Modified: 11/01/2010'
    } as IRarHelper,
    {
      code: 'N292',
      description: 'Missing/incomplete/invalid service facility name.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N293',
      description:
        'Missing/incomplete/invalid service facility primary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N294',
      description: 'Missing/incomplete/invalid service facility primary address.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N295',
      description:
        'Missing/incomplete/invalid service facility secondary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N296',
      description: 'Missing/incomplete/invalid supervising provider name.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N297',
      description:
        'Missing/incomplete/invalid supervising provider primary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N298',
      description:
        'Missing/incomplete/invalid supervising provider secondary identifier.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N299',
      description: 'Missing/incomplete/invalid occurrence date(s).Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N300',
      description: 'Missing/incomplete/invalid occurrence span date(s).Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N301',
      description: 'Missing/incomplete/invalid procedure date(s).Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N302',
      description: 'Missing/incomplete/invalid other procedure date(s).Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N303',
      description: 'Missing/incomplete/invalid principal procedure date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N304',
      description: 'Missing/incomplete/invalid dispensed date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N305',
      description:
        'Missing/incomplete/invalid injury/accident date.Start: 12/02/2004 | Last Modified: 11/01/2016Notes: (Modified 11/1/2016)',
      dates: 'Start: 12/02/2004 | Last Modified: 11/01/2016Notes: (Modified 11/1/2016)'
    } as IRarHelper,
    {
      code: 'N306',
      description: 'Missing/incomplete/invalid acute manifestation date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N307',
      description: 'Missing/incomplete/invalid adjudication or payment date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N308',
      description: 'Missing/incomplete/invalid appliance placement date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N309',
      description: 'Missing/incomplete/invalid assessment date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N310',
      description: 'Missing/incomplete/invalid assumed or relinquished care date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N311',
      description: 'Missing/incomplete/invalid authorized to return to work date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N312',
      description: 'Missing/incomplete/invalid begin therapy date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N313',
      description: 'Missing/incomplete/invalid certification revision date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N314',
      description: 'Missing/incomplete/invalid diagnosis date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N315',
      description: 'Missing/incomplete/invalid disability from date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N316',
      description: 'Missing/incomplete/invalid disability to date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N317',
      description: 'Missing/incomplete/invalid discharge hour.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N318',
      description: 'Missing/incomplete/invalid discharge or end of care date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N319',
      description:
        'Missing/incomplete/invalid hearing or vision prescription date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N320',
      description: 'Missing/incomplete/invalid Home Health Certification Period.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N321',
      description: 'Missing/incomplete/invalid last admission period.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N322',
      description: 'Missing/incomplete/invalid last certification date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N323',
      description: 'Missing/incomplete/invalid last contact date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N324',
      description: 'Missing/incomplete/invalid last seen/visit date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N325',
      description: 'Missing/incomplete/invalid last worked date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N326',
      description: 'Missing/incomplete/invalid last x-ray date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N327',
      description: 'Missing/incomplete/invalid other insured birth date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N328',
      description: 'Missing/incomplete/invalid Oxygen Saturation Test date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N329',
      description: 'Missing/incomplete/invalid patient birth date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N330',
      description: 'Missing/incomplete/invalid patient death date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N331',
      description: 'Missing/incomplete/invalid physician order date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N332',
      description: 'Missing/incomplete/invalid prior hospital discharge date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N333',
      description: 'Missing/incomplete/invalid prior placement date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N334',
      description:
        'Missing/incomplete/invalid re-evaluation date.Start: 12/02/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 12/02/2004 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N335',
      description: 'Missing/incomplete/invalid referral date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N336',
      description: 'Missing/incomplete/invalid replacement date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N337',
      description: 'Missing/incomplete/invalid secondary diagnosis date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N338',
      description: 'Missing/incomplete/invalid shipped date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N339',
      description: 'Missing/incomplete/invalid similar illness or symptom date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N340',
      description: 'Missing/incomplete/invalid subscriber birth date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N341',
      description: 'Missing/incomplete/invalid surgery date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N342',
      description: 'Missing/incomplete/invalid test performed date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N343',
      description:
        'Missing/incomplete/invalid Transcutaneous Electrical Nerve Stimulator (TENS) trial start date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N344',
      description:
        'Missing/incomplete/invalid Transcutaneous Electrical Nerve Stimulator (TENS) trial end date.Start: 12/02/2004',
      dates: 'Start: 12/02/2004'
    } as IRarHelper,
    {
      code: 'N345',
      description: 'Date range not valid with units submitted.Start: 03/30/2005',
      dates: 'Start: 03/30/2005'
    } as IRarHelper,
    {
      code: 'N346',
      description: 'Missing/incomplete/invalid oral cavity designation code.Start: 03/30/2005',
      dates: 'Start: 03/30/2005'
    } as IRarHelper,
    {
      code: 'N347',
      description:
        'Your claim for a referred or purchased service cannot be paid because payment has already been made for this same service to another provider by a payment contractor representing the payer.Start: 03/30/2005',
      dates: 'Start: 03/30/2005'
    } as IRarHelper,
    {
      code: 'N348',
      description:
        'You chose that this service/supply/drug would be rendered/supplied and billed by a different practitioner/supplier.Start: 08/01/2005',
      dates: 'Start: 08/01/2005'
    } as IRarHelper,
    {
      code: 'N349',
      description:
        'The administration method and drug must be reported to adjudicate this service.Start: 08/01/2005',
      dates: 'Start: 08/01/2005'
    } as IRarHelper,
    {
      code: 'N350',
      description:
        'Missing/incomplete/invalid description of service for a Not Otherwise Classified (NOC) code or for an Unlisted/By Report procedure.Start: 08/01/2005 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)',
      dates: 'Start: 08/01/2005 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)'
    } as IRarHelper,
    {
      code: 'N351',
      description:
        'Service date outside of the approved treatment plan service dates.Start: 08/01/2005',
      dates: 'Start: 08/01/2005'
    } as IRarHelper,
    {
      code: 'N352',
      description:
        'Alert: There are no scheduled payments for this service. Submit a claim for each patient visit.Start: 08/01/2005 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 08/01/2005 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N353',
      description:
        'Alert: Benefits have been estimated, when the actual services have been rendered, additional payment will be considered based on the submitted claim.Start: 08/01/2005 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 08/01/2005 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N354',
      description:
        'Incomplete/invalid invoice.Start: 08/01/2005 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 08/01/2005 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N355',
      description:
        'Alert: The law permits exceptions to the refund requirement in two cases: - If you did not know, and could not have reasonably been expected to know, that we would not pay for this service; or - If you notified the patient in writing before providing the service that you believed that we were likely to deny the service, and the patient signed a statement agreeing to pay for the service.\nIf you come within either exception, or if you believe the carrier was wrong in its determination that we do not pay for this service, you should request appeal of this determination within 30 days of the date of this notice. Your request for review should include any additional information necessary to support your position.\nIf you request an appeal within 30 days of receiving this notice, you may delay refunding the amount to the patient until you receive the results of the review. If the review decision is favorable to you, you do not need to make any refund. If, however, the review is unfavorable, the law specifies that you must make the refund within 15 days of receiving the unfavorable review decision.\nThe law also permits you to request an appeal at any time within 120 days of the date you receive this notice. However, an appeal request that is received more than 30 days after the date of this notice, does not permit you to delay making the refund. Regardless of when a review is requested, the patient will be notified that you have requested one, and will receive a copy of the determination.\nThe patient has received a separate notice of this denial decision. The notice advises that he/she may be entitled to a refund of any amounts paid, if you should have known that we would not pay and did not tell him/her. It also instructs the patient to contact our office if he/she does not hear anything about a refund within 30 daysStart: 08/01/2005 | Last Modified: 04/01/2007Notes: (Modified 11/18/05, Modified 4/1/07)',
      dates:
        'Start: 08/01/2005 | Last Modified: 04/01/2007Notes: (Modified 11/18/05, Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N356',
      description:
        'Not covered when performed with, or subsequent to, a non-covered service.Start: 08/01/2005 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)',
      dates: 'Start: 08/01/2005 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)'
    } as IRarHelper,
    {
      code: 'N357',
      description:
        'Time frame requirements between this service/procedure/supply and a related service/procedure/supply have not been met.Start: 11/18/2005',
      dates: 'Start: 11/18/2005'
    } as IRarHelper,
    {
      code: 'N358',
      description:
        'Alert: This decision may be reviewed if additional documentation as described in the contract or plan benefit documents is submitted.Start: 11/18/2005 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 11/18/2005 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N359',
      description: 'Missing/incomplete/invalid height.Start: 11/18/2005',
      dates: 'Start: 11/18/2005'
    } as IRarHelper,
    {
      code: 'N360',
      description:
        'Alert: Coordination of benefits has not been calculated when estimating benefits for this pre-determination. Submit payment information from the primary payer with the secondary claim.Start: 11/18/2005 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 11/18/2005 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N361',
      description:
        'Payment adjusted based on multiple diagnostic imaging procedure rulesStart: 11/18/2005 | Stop: 10/01/2007 | Last Modified: 12/01/2006Notes: (Modified 12/1/06) Consider using Reason Code 59',
      dates:
        'Start: 11/18/2005 | Stop: 10/01/2007 | Last Modified: 12/01/2006Notes: (Modified 12/1/06) Consider using Reason Code 59'
    } as IRarHelper,
    {
      code: 'N362',
      description:
        'The number of Days or Units of Service exceeds our acceptable maximum.Start: 11/18/2005',
      dates: 'Start: 11/18/2005'
    } as IRarHelper,
    {
      code: 'N363',
      description:
        'Alert: in the near future we are implementing new policies/procedures that would affect this determination.Start: 11/18/2005 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 11/18/2005 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N364',
      description:
        'Alert: According to our agreement, you must waive the deductible and/or coinsurance amounts.Start: 11/18/2005 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)',
      dates: 'Start: 11/18/2005 | Last Modified: 04/01/2007Notes: (Modified 4/1/07)'
    } as IRarHelper,
    {
      code: 'N365',
      description:
        'This procedure code is not payable. It is for reporting/information purposes only.Start: 04/01/2006 | Stop: 07/01/2014Notes: Consider Using CARC 246 or N620',
      dates: 'Start: 04/01/2006 | Stop: 07/01/2014Notes: Consider Using CARC 246 or N620'
    } as IRarHelper,
    {
      code: 'N366',
      description:
        'Requested information not provided. The claim will be reopened if the information previously requested is submitted within one year after the date of this denial notice.Start: 04/01/2006',
      dates: 'Start: 04/01/2006'
    } as IRarHelper,
    {
      code: 'N367',
      description:
        'Alert: The claim information has been forwarded to a Consumer Spending Account processor for review; for example, flexible spending account or health savings account.Start: 04/01/2006 | Last Modified: 07/01/2008Notes: (Modified 4/1/07, 11/5/07, 7/1/08)',
      dates:
        'Start: 04/01/2006 | Last Modified: 07/01/2008Notes: (Modified 4/1/07, 11/5/07, 7/1/08)'
    } as IRarHelper,
    {
      code: 'N368',
      description:
        'You must appeal the determination of the previously adjudicated claim.Start: 04/01/2006',
      dates: 'Start: 04/01/2006'
    } as IRarHelper,
    {
      code: 'N369',
      description:
        'Alert: Although this claim has been processed, it is deficient according to state legislation/regulation.Start: 04/01/2006',
      dates: 'Start: 04/01/2006'
    } as IRarHelper,
    {
      code: 'N370',
      description:
        'Billing exceeds the rental months covered/approved by the payer.Start: 08/01/2006',
      dates: 'Start: 08/01/2006'
    } as IRarHelper,
    {
      code: 'N371',
      description:
        'Alert: title of this equipment must be transferred to the patient.Start: 08/01/2006',
      dates: 'Start: 08/01/2006'
    } as IRarHelper,
    {
      code: 'N372',
      description:
        'Only reasonable and necessary maintenance/service charges are covered.Start: 08/01/2006',
      dates: 'Start: 08/01/2006'
    } as IRarHelper,
    {
      code: 'N373',
      description:
        'It has been determined that another payer paid the services as primary when they were not the primary payer. Therefore, we are refunding to the payer that paid as primary on your behalf.Start: 12/01/2006',
      dates: 'Start: 12/01/2006'
    } as IRarHelper,
    {
      code: 'N374',
      description:
        'Primary Medicare Part A insurance has been exhausted and a Part B Remittance Advice is required.Start: 12/01/2006',
      dates: 'Start: 12/01/2006'
    } as IRarHelper,
    {
      code: 'N375',
      description:
        'Missing/incomplete/invalid questionnaire/information required to determine dependent eligibility.Start: 12/01/2006',
      dates: 'Start: 12/01/2006'
    } as IRarHelper,
    {
      code: 'N376',
      description:
        'Subscriber/patient is assigned to active military duty, therefore primary coverage may be TRICARE.Start: 12/01/2006',
      dates: 'Start: 12/01/2006'
    } as IRarHelper,
    {
      code: 'N377',
      description:
        'Payment based on a processed replacement claim.Start: 12/01/2006 | Last Modified: 11/05/2007Notes: (Modified 11/5/07)',
      dates: 'Start: 12/01/2006 | Last Modified: 11/05/2007Notes: (Modified 11/5/07)'
    } as IRarHelper,
    {
      code: 'N378',
      description: 'Missing/incomplete/invalid prescription quantity.Start: 12/01/2006',
      dates: 'Start: 12/01/2006'
    } as IRarHelper,
    {
      code: 'N379',
      description:
        'Claim level information does not match line level information.Start: 12/01/2006',
      dates: 'Start: 12/01/2006'
    } as IRarHelper,
    {
      code: 'N380',
      description:
        'The original claim  has been processed, submit a corrected claim.Start: 04/01/2007',
      dates: 'Start: 04/01/2007'
    } as IRarHelper,
    {
      code: 'N381',
      description:
        'Alert: Consult our contractual agreement for restrictions/billing/payment information related to these charges.Start: 04/01/2007 | Last Modified: 07/01/2015Notes: (Modified 7/1/15)',
      dates: 'Start: 04/01/2007 | Last Modified: 07/01/2015Notes: (Modified 7/1/15)'
    } as IRarHelper,
    {
      code: 'N382',
      description: 'Missing/incomplete/invalid patient identifier.Start: 04/01/2007',
      dates: 'Start: 04/01/2007'
    } as IRarHelper,
    {
      code: 'N383',
      description:
        'Not covered when deemed cosmetic.Start: 04/01/2007 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)',
      dates: 'Start: 04/01/2007 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)'
    } as IRarHelper,
    {
      code: 'N384',
      description:
        'Records indicate that the referenced body part/tooth has been removed in a previous procedure.Start: 04/01/2007',
      dates: 'Start: 04/01/2007'
    } as IRarHelper,
    {
      code: 'N385',
      description:
        'Notification of admission was not timely according to published plan procedures.Start: 04/01/2007 | Last Modified: 11/05/2007Notes: (Modified 11/5/07)',
      dates: 'Start: 04/01/2007 | Last Modified: 11/05/2007Notes: (Modified 11/5/07)'
    } as IRarHelper,
    {
      code: 'N386',
      description:
        'This decision was based on a National Coverage Determination (NCD). An NCD provides a coverage determination as to whether a particular item or service is covered. A copy of this policy is available at www.cms.gov/mcd/search.asp. If you do not have web access, you may contact the contractor to request a copy of the NCD.Start: 04/01/2007 | Last Modified: 07/01/2010Notes: (Modified 7/1/2010)',
      dates: 'Start: 04/01/2007 | Last Modified: 07/01/2010Notes: (Modified 7/1/2010)'
    } as IRarHelper,
    {
      code: 'N387',
      description:
        "Alert: Submit this claim to the patient's other insurer for potential payment of supplemental benefits. We did not forward the claim information.Start: 04/01/2007 | Last Modified: 03/01/2009Notes: (Modified 3/1/2009)",
      dates: 'Start: 04/01/2007 | Last Modified: 03/01/2009Notes: (Modified 3/1/2009)'
    } as IRarHelper,
    {
      code: 'N388',
      description:
        'Missing/incomplete/invalid prescription number.Start: 08/01/2007 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 08/01/2007 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N389',
      description: 'Duplicate prescription number submitted.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N390',
      description:
        'This service/report cannot be billed separately.Start: 08/01/2007 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)',
      dates: 'Start: 08/01/2007 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)'
    } as IRarHelper,
    {
      code: 'N391',
      description: 'Missing emergency department records.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N392',
      description: 'Incomplete/invalid emergency department records.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N393',
      description:
        'Missing progress notes/report.Start: 08/01/2007 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)',
      dates: 'Start: 08/01/2007 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)'
    } as IRarHelper,
    {
      code: 'N394',
      description:
        'Incomplete/invalid progress notes/report.Start: 08/01/2007 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)',
      dates: 'Start: 08/01/2007 | Last Modified: 07/01/2008Notes: (Modified 7/1/08)'
    } as IRarHelper,
    {
      code: 'N395',
      description: 'Missing laboratory report.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N396',
      description: 'Incomplete/invalid laboratory report.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N397',
      description:
        'Benefits are not available for incomplete service(s)/undelivered item(s).Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N398',
      description: 'Missing elective consent form.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N399',
      description: 'Incomplete/invalid elective consent form.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N400',
      description:
        'Alert: Electronically enabled providers should submit claims electronically.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N401',
      description: 'Missing periodontal charting.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N402',
      description: 'Incomplete/invalid periodontal charting.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N403',
      description: 'Missing facility certification.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N404',
      description: 'Incomplete/invalid facility certification.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N405',
      description:
        "This service is only covered when the donor's insurer(s) do not provide coverage for the service.Start: 08/01/2007",
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N406',
      description:
        "This service is only covered when the recipient's insurer(s) do not provide coverage for the service.Start: 08/01/2007",
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N407',
      description:
        'You are not an approved submitter for this transmission format.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N408',
      description:
        'This payer does not cover deductibles assessed by a previous payer.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N409',
      description:
        'This service is related to an accidental injury and is not covered unless provided within a specific time frame from the date of the accident.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N410',
      description:
        'Not covered unless the prescription changes.Start: 08/01/2007 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)',
      dates: 'Start: 08/01/2007 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)'
    } as IRarHelper,
    {
      code: 'N411',
      description:
        'This service is allowed one time in a 6-month period.Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)',
      dates:
        'Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)'
    } as IRarHelper,
    {
      code: 'N412',
      description:
        'This service is allowed 2 times in a 12-month period.Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)',
      dates:
        'Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)'
    } as IRarHelper,
    {
      code: 'N413',
      description:
        'This service is allowed 2 times in a benefit year.Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)',
      dates:
        'Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)'
    } as IRarHelper,
    {
      code: 'N414',
      description:
        'This service is allowed 4 times in a 12-month period.Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)',
      dates:
        'Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)'
    } as IRarHelper,
    {
      code: 'N415',
      description:
        'This service is allowed 1 time in an 18-month period.Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)',
      dates:
        'Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)'
    } as IRarHelper,
    {
      code: 'N416',
      description:
        'This service is allowed 1 time in a 3-year period.Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)',
      dates:
        'Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)'
    } as IRarHelper,
    {
      code: 'N417',
      description:
        'This service is allowed 1 time in a 5-year period.Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)',
      dates:
        'Start: 08/01/2007 | Last Modified: 07/01/2016Notes: (Modified 2/1/2009, Reactivated 7/1/2016)'
    } as IRarHelper,
    {
      code: 'N418',
      description:
        "Misrouted claim.  See the payer's claim submission instructions.Start: 08/01/2007",
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N419',
      description:
        "Claim payment was the result of a payer's retroactive adjustment due to a retroactive rate change.Start: 08/01/2007",
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N420',
      description:
        "Claim payment was the result of a payer's retroactive adjustment due to a Coordination of Benefits or Third Party Liability Recovery.Start: 08/01/2007",
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N421',
      description:
        "Claim payment was the result of a payer's retroactive adjustment due to a review organization decision.Start: 08/01/2007 | Last Modified: 05/08/2008Notes: (Modified 2/29/08, typo fixed 5/8/08)",
      dates:
        'Start: 08/01/2007 | Last Modified: 05/08/2008Notes: (Modified 2/29/08, typo fixed 5/8/08)'
    } as IRarHelper,
    {
      code: 'N422',
      description:
        "Claim payment was the result of a payer's retroactive adjustment due to a payer's contract incentive program.Start: 08/01/2007 | Last Modified: 05/08/2008Notes: (Typo fixed 5/8/08)",
      dates: 'Start: 08/01/2007 | Last Modified: 05/08/2008Notes: (Typo fixed 5/8/08)'
    } as IRarHelper,
    {
      code: 'N423',
      description:
        "Claim payment was the result of a payer's retroactive adjustment due to a non standard program.Start: 08/01/2007",
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N424',
      description:
        'Patient does not reside in the geographic area required for this type of payment.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N425',
      description: 'Statutorily excluded service(s).Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N426',
      description: 'No coverage when self-administered.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N427',
      description:
        'Payment for eyeglasses or contact lenses can be made only after cataract surgery.Start: 08/01/2007',
      dates: 'Start: 08/01/2007'
    } as IRarHelper,
    {
      code: 'N428',
      description:
        'Not covered when performed in this place of service.Start: 08/01/2007 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)',
      dates: 'Start: 08/01/2007 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)'
    } as IRarHelper,
    {
      code: 'N429',
      description:
        'Not covered when considered routine.Start: 08/01/2007 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)',
      dates: 'Start: 08/01/2007 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)'
    } as IRarHelper,
    {
      code: 'N430',
      description: 'Procedure code is inconsistent with the units billed.Start: 11/05/2007',
      dates: 'Start: 11/05/2007'
    } as IRarHelper,
    {
      code: 'N431',
      description:
        'Not covered with this procedure.Start: 11/05/2007 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)',
      dates: 'Start: 11/05/2007 | Last Modified: 03/08/2011Notes: (Modified 3/8/11)'
    } as IRarHelper,
    {
      code: 'N432',
      description:
        'Alert: Adjustment based on a Recovery Audit.Start: 11/05/2007 | Last Modified: 07/01/2015Notes: (Modified 7/1/15)',
      dates: 'Start: 11/05/2007 | Last Modified: 07/01/2015Notes: (Modified 7/1/15)'
    } as IRarHelper,
    {
      code: 'N433',
      description:
        'Resubmit this claim using only your National Provider Identifier (NPI).Start: 02/29/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 02/29/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N434',
      description: 'Missing/Incomplete/Invalid Present on Admission indicator.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N435',
      description:
        'Exceeds number/frequency approved /allowed within time period without support documentation.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N436',
      description:
        'The injury claim has not been accepted and a mandatory medical reimbursement has been made.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N437',
      description:
        'Alert: If the injury claim is accepted, these charges will be reconsidered.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N438',
      description:
        'This jurisdiction only accepts paper claims.Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N439',
      description: 'Missing anesthesia physical status report/indicators.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N440',
      description:
        'Incomplete/invalid anesthesia physical status report/indicators.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N441',
      description:
        'This missed/cancelled appointment is not covered.Start: 07/01/2008 | Last Modified: 07/15/2013Notes: (Modified 7/15/2013)',
      dates: 'Start: 07/01/2008 | Last Modified: 07/15/2013Notes: (Modified 7/15/2013)'
    } as IRarHelper,
    {
      code: 'N442',
      description: 'Payment based on an alternate fee schedule.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N443',
      description: 'Missing/incomplete/invalid total time or begin/end time.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N444',
      description:
        "Alert: This facility has not filed the Election for High Cost Outlier form with the Division of Workers' Compensation.Start: 07/01/2008",
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N445',
      description: 'Missing document for actual cost or paid amount.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N446',
      description: 'Incomplete/invalid document for actual cost or paid amount.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N447',
      description:
        'Payment is based on a generic equivalent as required documentation was not provided.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N448',
      description:
        'This drug/service/supply is not included in the fee schedule or contracted/legislated fee arrangement.Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N449',
      description: 'Payment based on a comparable drug/service/supply.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N450',
      description:
        'Covered only when performed by the primary treating physician or the designee.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N451',
      description: 'Missing Admission Summary Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N452',
      description: 'Incomplete/invalid Admission Summary Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N453',
      description: 'Missing Consultation Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N454',
      description: 'Incomplete/invalid Consultation Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N455',
      description: 'Missing Physician Order.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N456',
      description: 'Incomplete/invalid Physician Order.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N457',
      description: 'Missing Diagnostic Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N458',
      description: 'Incomplete/invalid Diagnostic Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N459',
      description: 'Missing Discharge Summary.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N460',
      description: 'Incomplete/invalid Discharge Summary.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N461',
      description: 'Missing Nursing Notes.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N462',
      description: 'Incomplete/invalid Nursing Notes.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N463',
      description: 'Missing support data for claim.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N464',
      description: 'Incomplete/invalid support data for claim.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N465',
      description: 'Missing Physical Therapy Notes/Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N466',
      description: 'Incomplete/invalid Physical Therapy Notes/Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N467',
      description:
        'Missing Tests and Analysis Report.Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N468',
      description: 'Incomplete/invalid Report of Tests and Analysis Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N469',
      description:
        'Alert: Claim/Service(s) subject to appeal process, see section 935 of Medicare Prescription Drug, Improvement, and Modernization Act of 2003 (MMA).Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N470',
      description:
        'This payment will complete the mandatory medical reimbursement limit.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N471',
      description: 'Missing/incomplete/invalid HIPPS Rate Code.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N472',
      description: 'Payment for this service has been issued to another provider.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N473',
      description: 'Missing certification.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N474',
      description:
        'Incomplete/invalid certification.Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N475',
      description: 'Missing completed referral form.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N476',
      description:
        'Incomplete/invalid completed referral form.Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N477',
      description: 'Missing Dental Models.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N478',
      description:
        'Incomplete/invalid Dental Models.Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N479',
      description:
        'Missing Explanation of Benefits (Coordination of Benefits or Medicare Secondary Payer).Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N480',
      description:
        'Incomplete/invalid Explanation of Benefits (Coordination of Benefits or Medicare Secondary Payer).Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N481',
      description: 'Missing Models.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N482',
      description:
        'Incomplete/invalid Models.Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N483',
      description:
        'Missing Periodontal Charts.Start: 07/01/2008 | Stop: 05/01/2015 | Last Modified: 11/01/2014Notes: (Modified 11/1/2014)',
      dates:
        'Start: 07/01/2008 | Stop: 05/01/2015 | Last Modified: 11/01/2014Notes: (Modified 11/1/2014)'
    } as IRarHelper,
    {
      code: 'N484',
      description:
        'Incomplete/invalid Periodontal Charts.Start: 07/01/2008 | Stop: 05/01/2015 | Last Modified: 11/01/2014Notes: (Modified 3/14/2014, 11/1/2014)',
      dates:
        'Start: 07/01/2008 | Stop: 05/01/2015 | Last Modified: 11/01/2014Notes: (Modified 3/14/2014, 11/1/2014)'
    } as IRarHelper,
    {
      code: 'N485',
      description: 'Missing Physical Therapy Certification.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N486',
      description: 'Incomplete/invalid Physical Therapy Certification.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N487',
      description: 'Missing Prosthetics or Orthotics Certification.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N488',
      description:
        'Incomplete/invalid Prosthetics or Orthotics Certification.Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N489',
      description: 'Missing referral form.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N490',
      description:
        'Incomplete/invalid referral form.Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/01/2008 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N491',
      description: 'Missing/Incomplete/Invalid Exclusionary Rider Condition.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N492',
      description:
        'Alert: A network provider may bill the member for this service if the member requested the service and agreed in writing, prior to receiving the service, to be financially responsible for the billed charge.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N493',
      description: 'Missing Doctor First Report of Injury.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N494',
      description: 'Incomplete/invalid Doctor First Report of Injury.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N495',
      description: 'Missing Supplemental Medical Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N496',
      description: 'Incomplete/invalid Supplemental Medical Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N497',
      description: 'Missing Medical Permanent Impairment or Disability Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N498',
      description:
        'Incomplete/invalid Medical Permanent Impairment or Disability Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N499',
      description: 'Missing Medical Legal Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N500',
      description: 'Incomplete/invalid Medical Legal Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N501',
      description: 'Missing Vocational Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N502',
      description: 'Incomplete/invalid Vocational Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N503',
      description: 'Missing Work Status Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N504',
      description: 'Incomplete/invalid Work Status Report.Start: 07/01/2008',
      dates: 'Start: 07/01/2008'
    } as IRarHelper,
    {
      code: 'N505',
      description:
        'Alert: This response includes only services that could be estimated in real-time. No estimate will be provided for the services that could not be estimated in real-time.Start: 11/01/2008 | Last Modified: 03/01/2017Notes: (Modified 3/1/2017)',
      dates: 'Start: 11/01/2008 | Last Modified: 03/01/2017Notes: (Modified 3/1/2017)'
    } as IRarHelper,
    {
      code: 'N506',
      description:
        'Alert: This is an estimate of the member’s liability based on the information available at the time the estimate was processed. Actual coverage and member liability amounts will be determined when the claim is processed. This is not a pre-authorization or a guarantee of payment.Start: 11/01/2008',
      dates: 'Start: 11/01/2008'
    } as IRarHelper,
    {
      code: 'N507',
      description: 'Plan distance requirements have not been met.Start: 11/01/2008',
      dates: 'Start: 11/01/2008'
    } as IRarHelper,
    {
      code: 'N508',
      description:
        'Alert: This real-time claim adjudication response represents the member responsibility to the provider for services reported. The member will receive an Explanation of Benefits electronically or in the mail. Contact the insurer if there are any questions.Start: 11/01/2008 | Last Modified: 03/01/2017Notes: (Modified 3/1/2017)',
      dates: 'Start: 11/01/2008 | Last Modified: 03/01/2017Notes: (Modified 3/1/2017)'
    } as IRarHelper,
    {
      code: 'N509',
      description:
        'Alert: A current inquiry shows the member’s Consumer Spending Account contains sufficient funds to cover the member liability for this claim/service.  Actual payment from the Consumer Spending Account will depend on the availability of funds and determination of eligible services at the time of payment processing.Start: 11/01/2008',
      dates: 'Start: 11/01/2008'
    } as IRarHelper,
    {
      code: 'N510',
      description:
        "Alert: A current inquiry shows the member’s Consumer Spending Account does not contain sufficient funds to cover the Member's liability for this claim/service. Actual payment from the Consumer Spending Account will depend on the availability of funds and determination of eligible services at the time of payment processing.Start: 11/01/2008",
      dates: 'Start: 11/01/2008'
    } as IRarHelper,
    {
      code: 'N511',
      description:
        'Alert: Information on the availability of Consumer Spending Account funds to cover the member liability on this claim/service is not available at this time.Start: 11/01/2008',
      dates: 'Start: 11/01/2008'
    } as IRarHelper,
    {
      code: 'N512',
      description:
        'Alert: This is the initial remit of a non-NCPDP claim originally submitted real-time without change to the adjudication.Start: 11/01/2008',
      dates: 'Start: 11/01/2008'
    } as IRarHelper,
    {
      code: 'N513',
      description:
        'Alert: This is the initial remit of a non-NCPDP claim originally submitted real-time with a change to the adjudication.Start: 11/01/2008',
      dates: 'Start: 11/01/2008'
    } as IRarHelper,
    {
      code: 'N514',
      description:
        'Consult plan benefit documents/guidelines for information about restrictions for this service.Start: 11/01/2008 | Stop: 01/01/2011Notes: Consider using N130',
      dates: 'Start: 11/01/2008 | Stop: 01/01/2011Notes: Consider using N130'
    } as IRarHelper,
    {
      code: 'N515',
      description:
        "Alert: Submit this claim to the patient's other insurer for potential payment of supplemental benefits. We did not forward the claim information. (use N387 instead)Start: 11/01/2008 | Stop: 10/01/2009",
      dates: 'Start: 11/01/2008 | Stop: 10/01/2009'
    } as IRarHelper,
    {
      code: 'N516',
      description:
        'Records indicate a mismatch between the submitted NPI and EIN.Start: 03/01/2009',
      dates: 'Start: 03/01/2009'
    } as IRarHelper,
    {
      code: 'N517',
      description: 'Resubmit a new claim with the requested information.Start: 03/01/2009',
      dates: 'Start: 03/01/2009'
    } as IRarHelper,
    {
      code: 'N518',
      description:
        'No separate payment for accessories when furnished for use with oxygen equipment.Start: 03/01/2009',
      dates: 'Start: 03/01/2009'
    } as IRarHelper,
    {
      code: 'N519',
      description: 'Invalid combination of HCPCS modifiers.Start: 07/01/2009',
      dates: 'Start: 07/01/2009'
    } as IRarHelper,
    {
      code: 'N520',
      description: 'Alert: Payment made from a Consumer Spending Account.Start: 07/01/2009',
      dates: 'Start: 07/01/2009'
    } as IRarHelper,
    {
      code: 'N521',
      description:
        'Mismatch between the submitted provider information and the provider information stored in our system.Start: 11/01/2009',
      dates: 'Start: 11/01/2009'
    } as IRarHelper,
    {
      code: 'N522',
      description:
        'Duplicate of a claim processed, or to be processed, as a crossover claim.Start: 11/01/2009 | Last Modified: 03/01/2010',
      dates: 'Start: 11/01/2009 | Last Modified: 03/01/2010'
    } as IRarHelper,
    {
      code: 'N523',
      description:
        'The limitation on outlier payments defined by this payer for this service period has been met. The outlier payment otherwise applicable to this claim has not been paid.Start: 03/01/2010',
      dates: 'Start: 03/01/2010'
    } as IRarHelper,
    {
      code: 'N524',
      description: 'Based on policy this payment constitutes payment in full.Start: 03/01/2010',
      dates: 'Start: 03/01/2010'
    } as IRarHelper,
    {
      code: 'N525',
      description:
        'These services are not covered when performed within the global period of another service.Start: 03/01/2010',
      dates: 'Start: 03/01/2010'
    } as IRarHelper,
    {
      code: 'N526',
      description: 'Not qualified for recovery based on employer size.Start: 03/01/2010',
      dates: 'Start: 03/01/2010'
    } as IRarHelper,
    {
      code: 'N527',
      description:
        'We processed this claim as the primary payer prior to receiving the recovery demand.Start: 03/01/2010',
      dates: 'Start: 03/01/2010'
    } as IRarHelper,
    {
      code: 'N528',
      description:
        'Patient is entitled to benefits for Institutional Services only.Start: 03/01/2010 | Last Modified: 07/01/2010Notes: (Modified 7/1/10)',
      dates: 'Start: 03/01/2010 | Last Modified: 07/01/2010Notes: (Modified 7/1/10)'
    } as IRarHelper,
    {
      code: 'N529',
      description:
        'Patient is entitled to benefits for Professional Services only.Start: 03/01/2010 | Last Modified: 07/01/2010Notes: (Modified 7/1/10)',
      dates: 'Start: 03/01/2010 | Last Modified: 07/01/2010Notes: (Modified 7/1/10)'
    } as IRarHelper,
    {
      code: 'N530',
      description:
        'Not Qualified for Recovery based on enrollment information.Start: 03/01/2010 | Last Modified: 07/01/2010Notes: (Modified 7/1/10)',
      dates: 'Start: 03/01/2010 | Last Modified: 07/01/2010Notes: (Modified 7/1/10)'
    } as IRarHelper,
    {
      code: 'N531',
      description:
        'Not qualified for recovery based on direct payment of premium.Start: 03/01/2010',
      dates: 'Start: 03/01/2010'
    } as IRarHelper,
    {
      code: 'N532',
      description:
        'Not qualified for recovery based on disability and working status.Start: 03/01/2010',
      dates: 'Start: 03/01/2010'
    } as IRarHelper,
    {
      code: 'N533',
      description:
        'Services performed in an Indian Health Services facility under a self-insured tribal Group Health Plan.Start: 07/01/2010',
      dates: 'Start: 07/01/2010'
    } as IRarHelper,
    {
      code: 'N534',
      description:
        'This is an individual policy, the employer does not participate in plan sponsorship.Start: 07/01/2010',
      dates: 'Start: 07/01/2010'
    } as IRarHelper,
    {
      code: 'N535',
      description:
        'Payment is adjusted when procedure is performed in this place of service based on the submitted procedure code and place of service.Start: 07/01/2010',
      dates: 'Start: 07/01/2010'
    } as IRarHelper,
    {
      code: 'N536',
      description:
        "We are not changing the prior payer's determination of patient responsibility, which you may collect, as this service is not covered by us.Start: 07/01/2010",
      dates: 'Start: 07/01/2010'
    } as IRarHelper,
    {
      code: 'N537',
      description:
        'We have examined claims history and no records of the services have been found.Start: 07/01/2010',
      dates: 'Start: 07/01/2010'
    } as IRarHelper,
    {
      code: 'N538',
      description:
        'A facility is responsible for payment to outside providers who furnish these services/supplies/drugs to its patients/residents.Start: 07/01/2010',
      dates: 'Start: 07/01/2010'
    } as IRarHelper,
    {
      code: 'N539',
      description:
        'Alert: We processed appeals/waiver requests on your behalf and that request has been denied.Start: 07/01/2010',
      dates: 'Start: 07/01/2010'
    } as IRarHelper,
    {
      code: 'N540',
      description: 'Payment adjusted based on the interrupted stay policy.Start: 11/01/2010',
      dates: 'Start: 11/01/2010'
    } as IRarHelper,
    {
      code: 'N541',
      description:
        'Mismatch between the submitted insurance type code and the information stored in our system.Start: 11/01/2010',
      dates: 'Start: 11/01/2010'
    } as IRarHelper,
    {
      code: 'N542',
      description: 'Missing income verification.Start: 03/08/2011',
      dates: 'Start: 03/08/2011'
    } as IRarHelper,
    {
      code: 'N543',
      description:
        'Incomplete/invalid income verification.Start: 03/08/2011 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 03/08/2011 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N544',
      description:
        'Alert: Although this was paid, you have billed with a referring/ordering provider that does not match our system record. Unless corrected this will not be paid in the future.Start: 07/01/2011 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/01/2011 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N545',
      description:
        'Payment reduced based on status as an unsuccessful eprescriber per the Electronic Prescribing (eRx) Incentive Program.Start: 07/01/2011',
      dates: 'Start: 07/01/2011'
    } as IRarHelper,
    {
      code: 'N546',
      description:
        'Payment represents a previous reduction based on the Electronic Prescribing (eRx) Incentive Program.Start: 07/01/2011',
      dates: 'Start: 07/01/2011'
    } as IRarHelper,
    {
      code: 'N547',
      description:
        'A refund request (Frequency Type Code 8) was processed previously.Start: 03/06/2012',
      dates: 'Start: 03/06/2012'
    } as IRarHelper,
    {
      code: 'N548',
      description: "Alert: patient's calendar year deductible has been met.Start: 03/06/2012",
      dates: 'Start: 03/06/2012'
    } as IRarHelper,
    {
      code: 'N549',
      description:
        "Alert: patient's calendar year out-of-pocket maximum has been met.Start: 03/06/2012",
      dates: 'Start: 03/06/2012'
    } as IRarHelper,
    {
      code: 'N550',
      description:
        'Alert: You have not responded to requests to revalidate your provider/supplier enrollment information. Your failure to revalidate your enrollment information will result in a payment hold in the near future.Start: 03/06/2012',
      dates: 'Start: 03/06/2012'
    } as IRarHelper,
    {
      code: 'N551',
      description:
        'Payment adjusted based on the Ambulatory Surgical Center (ASC) Quality Reporting Program.Start: 03/06/2012',
      dates: 'Start: 03/06/2012'
    } as IRarHelper,
    {
      code: 'N552',
      description: 'Payment adjusted to reverse a previous withhold/bonus amount.Start: 03/06/2012',
      dates: 'Start: 03/06/2012'
    } as IRarHelper,
    {
      code: 'N553',
      description:
        'Payment adjusted based on a Low Income Subsidy (LIS) retroactive coverage or status change.Start: 03/06/2012 | Stop: 11/01/2012',
      dates: 'Start: 03/06/2012 | Stop: 11/01/2012'
    } as IRarHelper,
    {
      code: 'N554',
      description:
        'Missing/Incomplete/Invalid Family Planning Indicator.Start: 07/01/2012 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/01/2012 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N555',
      description: 'Missing medication list.Start: 07/01/2012',
      dates: 'Start: 07/01/2012'
    } as IRarHelper,
    {
      code: 'N556',
      description: 'Incomplete/invalid medication list.Start: 07/01/2012',
      dates: 'Start: 07/01/2012'
    } as IRarHelper,
    {
      code: 'N557',
      description:
        'This claim/service is not payable under our service area. The claim must be filed to the Payer/Plan in whose service area the specimen was collected.Start: 07/01/2012',
      dates: 'Start: 07/01/2012'
    } as IRarHelper,
    {
      code: 'N558',
      description:
        'This claim/service is not payable under our service area. The claim must be filed to the Payer/Plan in whose service area the equipment was received.Start: 07/01/2012',
      dates: 'Start: 07/01/2012'
    } as IRarHelper,
    {
      code: 'N559',
      description:
        'This claim/service is not payable under our service area. The claim must be filed to the Payer/Plan in whose service area the Ordering Physician is located.Start: 07/01/2012',
      dates: 'Start: 07/01/2012'
    } as IRarHelper,
    {
      code: 'N560',
      description:
        'The pilot program requires an interim or final claim within 60 days of the Notice of  Admission. A claim was not received.Start: 11/01/2012',
      dates: 'Start: 11/01/2012'
    } as IRarHelper,
    {
      code: 'N561',
      description:
        'The bundled claim originally submitted for this episode of care includes related readmissions. You may resubmit the original claim to receive a corrected payment based on this readmission.Start: 11/01/2012',
      dates: 'Start: 11/01/2012'
    } as IRarHelper,
    {
      code: 'N562',
      description:
        'The provider number of your incoming claim does not match the provider number on the processed Notice of Admission (NOA) for this bundled payment.Start: 11/01/2012',
      dates: 'Start: 11/01/2012'
    } as IRarHelper,
    {
      code: 'N563',
      description:
        'Alert: Missing required provider/supplier issuance of advance patient notice of non-coverage. The patient is not liable for payment for this service.Start: 11/01/2012 | Last Modified: 11/01/2015Notes: Related to M39 (Modified 11/1/2015)',
      dates:
        'Start: 11/01/2012 | Last Modified: 11/01/2015Notes: Related to M39 (Modified 11/1/2015)'
    } as IRarHelper,
    {
      code: 'N564',
      description:
        'Patient did not meet the inclusion criteria for the demonstration project or pilot program.Start: 11/01/2012',
      dates: 'Start: 11/01/2012'
    } as IRarHelper,
    {
      code: 'N565',
      description:
        'Alert: This non-payable reporting code requires a modifier. Future claims containing this non-payable reporting code must include an appropriate modifier for the claim to be processed.Start: 11/01/2012 | Last Modified: 03/01/2013Notes: (Modified 3/1/13)',
      dates: 'Start: 11/01/2012 | Last Modified: 03/01/2013Notes: (Modified 3/1/13)'
    } as IRarHelper,
    {
      code: 'N566',
      description:
        'Alert: This procedure code requires functional reporting. Future claims containing this procedure code must include an applicable non-payable code and appropriate modifiers for the claim to be processed.Start: 11/01/2012',
      dates: 'Start: 11/01/2012'
    } as IRarHelper,
    {
      code: 'N567',
      description: 'Not covered when considered preventative.Start: 03/01/2013',
      dates: 'Start: 03/01/2013'
    } as IRarHelper,
    {
      code: 'N568',
      description:
        'Alert: Initial payment based on the Notice of Admission (NOA) under the Bundled Payment Model IV initiative.Start: 03/01/2013',
      dates: 'Start: 03/01/2013'
    } as IRarHelper,
    {
      code: 'N569',
      description: 'Not covered when performed for the reported diagnosis.Start: 03/01/2013',
      dates: 'Start: 03/01/2013'
    } as IRarHelper,
    {
      code: 'N570',
      description:
        'Missing/incomplete/invalid credentialing data.Start: 03/01/2013 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 03/01/2013 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N571',
      description:
        'Alert: Payment will be issued quarterly by another payer/contractor.Start: 03/01/2013',
      dates: 'Start: 03/01/2013'
    } as IRarHelper,
    {
      code: 'N572',
      description:
        'This procedure is not payable unless appropriate non-payable reporting codes and associated modifiers are submitted.Start: 03/01/2013 | Last Modified: 07/01/2014',
      dates: 'Start: 03/01/2013 | Last Modified: 07/01/2014'
    } as IRarHelper,
    {
      code: 'N573',
      description:
        'Alert: You have been overpaid and must refund the overpayment. The refund will be requested separately by another payer/contractor.Start: 03/01/2013',
      dates: 'Start: 03/01/2013'
    } as IRarHelper,
    {
      code: 'N574',
      description:
        'Our records indicate the ordering/referring provider is of a type/specialty that cannot order or refer. Please verify that the claim ordering/referring provider information is accurate or contact the ordering/referring provider.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N575',
      description:
        'Mismatch between the submitted ordering/referring provider name and the ordering/referring provider name stored in our records.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N576',
      description:
        'Services not related to the specific incident/claim/accident/loss being reported.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N577',
      description: 'Personal Injury Protection (PIP) Coverage.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N578',
      description: 'Coverages do not apply to this loss.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N579',
      description: 'Medical Payments Coverage (MPC).Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N580',
      description:
        'Determination based on the provisions of the insurance policy.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N581',
      description: 'Investigation of coverage eligibility is pending.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N582',
      description: "Benefits suspended pending the patient's cooperation.Start: 07/15/2013",
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N583',
      description:
        'Patient was not an occupant of our insured vehicle and therefore, is not an eligible injured person.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N584',
      description:
        "Not covered based on the insured's noncompliance with policy or statutory conditions.Start: 07/15/2013",
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N585',
      description:
        'Benefits are no longer available based on a final injury settlement.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N586',
      description: 'The injured party does not qualify for benefits.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N587',
      description: 'Policy benefits have been exhausted.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N588',
      description:
        'The patient has instructed that medical claims/bills are not to be paid.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N589',
      description:
        'Coverage is excluded to any person injured as a result of operating a motor vehicle while in an intoxicated condition or while the ability to operate such a vehicle is impaired by the use of a drug.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N590',
      description:
        'Missing independent medical exam detailing the cause of injuries sustained and medical necessity of services rendered.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N591',
      description:
        'Payment based on an Independent Medical Examination (IME) or Utilization Review (UR).Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N592',
      description:
        'Adjusted because this is not the initial prescription or exceeds the amount allowed for the initial prescription.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N593',
      description:
        'Not covered based on failure to attend  a scheduled Independent Medical Exam (IME).Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N594',
      description:
        'Records reflect the injured party did not complete an Application for Benefits for this loss.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N595',
      description:
        'Records reflect the injured party did not complete an Assignment of Benefits for this loss.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N596',
      description:
        'Records reflect the injured party did not complete a Medical Authorization for this loss.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N597',
      description:
        "Adjusted based on a medical/dental provider's apportionment of care between related injuries and other unrelated medical/dental conditions/injuries.Start: 07/15/2013 | Last Modified: 11/01/2013",
      dates: 'Start: 07/15/2013 | Last Modified: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N598',
      description: 'Health care policy coverage is primary.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N599',
      description:
        'Our payment for this service is based upon a reasonable amount pursuant to both the terms and conditions of the policy of insurance under which the subject claim is being made as well as the Florida No-Fault Statute, which permits, when determining a reasonable charge for a service, an insurer to consider usual and customary charges and payments accepted by the provider, reimbursement levels in the community and various federal and state fee schedules applicable to automobile and other insurance coverages, and other information relevant to the reasonableness of the reimbursement for the service. The payment for this service is based upon 200% of the Participating Level of Medicare Part B fee schedule for the locale in which the services were rendered.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N600',
      description:
        'Adjusted based on the applicable fee schedule for the region in which the service was rendered.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N601',
      description:
        'In accordance with Hawaii Administrative Rules, Title 16, Chapter 23 Motor Vehicle Insurance Law payment is recommended based on Medicare Resource Based Relative Value Scale System applicable to Hawaii.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N602',
      description: 'Adjusted based on the Redbook maximum allowance.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N603',
      description:
        'This fee is calculated according to the New Jersey medical fee schedules for Automobile Personal Injury Protection and Motor Bus Medical Expense Insurance Coverage.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N604',
      description:
        "In accordance with New York No-Fault Law, Regulation 68, this base fee was calculated according to the New York Workers' Compensation Board Schedule of Medical Fees, pursuant to Regulation 83 and / or Appendix 17-C of 11 NYCRR.Start: 07/15/2013",
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N605',
      description:
        'This fee was calculated based upon New York All Patients Refined Diagnosis Related Groups (APR-DRG), pursuant to Regulation 68.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N606',
      description:
        'The Oregon allowed amount for this procedure is based upon the Workers Compensation Fee Schedule (OAR 436-009).  The allowed amount has been calculated in accordance with Section 4 of ORS 742.524.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N607',
      description: 'Service provided for non-compensable condition(s).Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N608',
      description:
        'The fee schedule amount allowed is calculated at 110% of the Medicare Fee Schedule for this region, specialty and type of service.  This fee is calculated in compliance with Act 6.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N609',
      description:
        "80% of the provider's billed amount is being recommended for payment according to Act 6.Start: 07/15/2013 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)",
      dates: 'Start: 07/15/2013 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N610',
      description: 'Alert: Payment based on an appropriate level of care.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N611',
      description: 'Claim in litigation.  Contact insurer for more information.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N612',
      description:
        'Medical provider not authorized/certified to provide treatment to  injured workers in this jurisdiction.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N613',
      description:
        'Alert: Although this was paid, you have billed with an ordering provider that needs to update their enrollment record. Please verify that the ordering provider information you submitted on the claim is accurate and if it is, contact the ordering provider instructing them to update their enrollment record. Unless corrected, a claim with this ordering provider will not be paid in the future.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N614',
      description:
        'Alert: Additional information is included in the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information).Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N615',
      description:
        'Alert: This enrollee receiving advance payments of the premium tax credit is in the grace period of three consecutive months for non-payment of premium. Under 45 CFR 156.270, a Qualified Health Plan issuer must pay all appropriate claims for services rendered to the enrollee during the first month of the grace period and may pend claims for services rendered to the enrollee in the second and third months of the grace period.Start: 07/15/2013 | Last Modified: 03/01/2017Notes: (Modified 3/1/2017)',
      dates: 'Start: 07/15/2013 | Last Modified: 03/01/2017Notes: (Modified 3/1/2017)'
    } as IRarHelper,
    {
      code: 'N616',
      description:
        'Alert: This enrollee is in the first month of the advance premium tax credit grace period.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N617',
      description:
        'This enrollee is in the second or third month of the advance premium tax credit grace period.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N618',
      description:
        'Alert: This claim will automatically be reprocessed if the enrollee pays their premiums.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N619',
      description: 'Coverage terminated for non-payment of premium.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N620',
      description:
        'Alert: This procedure code is for quality reporting/informational purposes only.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N621',
      description:
        'Charges for Jurisdiction required forms, reports, or chart notes are not payable.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N622',
      description: 'Not covered based on the date of injury/accident.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N623',
      description:
        'Not covered when deemed unscientific/unproven/outmoded/experimental/excessive/inappropriate.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N624',
      description:
        "The associated Workers' Compensation claim has been withdrawn.Start: 07/15/2013",
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N625',
      description:
        "Missing/Incomplete/Invalid Workers' Compensation Claim Number.Start: 07/15/2013",
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N626',
      description:
        'New or established patient E/M codes are not payable with chiropractic care codes.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N627',
      description:
        'Service not payable per managed care contract.Start: 07/15/2013 | Stop: 07/01/2014Notes: Consider Use CARC 256',
      dates: 'Start: 07/15/2013 | Stop: 07/01/2014Notes: Consider Use CARC 256'
    } as IRarHelper,
    {
      code: 'N628',
      description:
        'Out-patient follow up visits on the same date of service as a scheduled test or treatment is disallowed.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N629',
      description:
        'Reviews/documentation/notes/summaries/reports/charts not requested.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N630',
      description: 'Referral not authorized by attending physician.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N631',
      description:
        'Medical Fee Schedule does not list this code. An allowance was made for a comparable service.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N632',
      description:
        'According to the Official Medical Fee Schedule this service has a relative value of zero and therefore no payment is due.Start: 07/15/2013 | Stop: 07/01/2014Notes: Consider using W8',
      dates: 'Start: 07/15/2013 | Stop: 07/01/2014Notes: Consider using W8'
    } as IRarHelper,
    {
      code: 'N633',
      description: 'Additional anesthesia time units are not allowed.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N634',
      description: 'The allowance is calculated based on anesthesia time units.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N635',
      description:
        'The Allowance is calculated based on the anesthesia base units plus time.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N636',
      description: 'Adjusted because this is reimbursable only once per injury.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N637',
      description:
        'Consultations are not allowed once treatment has been rendered by the same provider.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N638',
      description:
        'Reimbursement has been made according to the home health fee schedule.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N639',
      description:
        'Reimbursement has been made according to the inpatient rehabilitation facilities fee schedule.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N640',
      description: 'Exceeds number/frequency approved/allowed within time period.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N641',
      description:
        'Reimbursement has been based on the number of body areas rated.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N642',
      description:
        'Adjusted when billed as individual tests instead of as a panel.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N643',
      description:
        'The services billed are considered Not Covered or Non-Covered (NC) in the applicable state fee schedule.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N644',
      description:
        'Reimbursement has been made according to the bilateral procedure rule.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N645',
      description:
        'Mark-up allowance.Start: 07/15/2013 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/15/2013 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N646',
      description:
        'Reimbursement has been adjusted based on the guidelines for an assistant.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N647',
      description: 'Adjusted based on diagnosis-related group (DRG).Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N648',
      description: 'Adjusted based on Stop Loss.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N649',
      description: 'Payment based on invoice.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N650',
      description:
        'This policy was not in effect for this date of loss. No coverage is available.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N651',
      description:
        'No Personal Injury Protection/Medical Payments Coverage on the policy at the time of the loss.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N652',
      description: 'The date of service is before the date of loss.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N653',
      description: 'The date of injury does not match the reported date of loss.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N654',
      description:
        'Adjusted based on achievement of maximum medical improvement (MMI).Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N655',
      description: "Payment based on provider's geographic region.Start: 07/15/2013",
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N656',
      description:
        'An interest payment is being made because benefits are being paid outside the statutory requirement.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N657',
      description:
        'This should be billed with the appropriate code for these services.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N658',
      description: 'The billed service(s) are not considered medical expenses.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N659',
      description: 'This item is exempt from sales tax.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N660',
      description: 'Sales tax has been included in the reimbursement.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N661',
      description:
        'Documentation does not support that the services rendered were medically necessary.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N662',
      description:
        'Alert: Consideration of payment will be made upon receipt of a final bill.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N663',
      description: 'Adjusted based on an agreed amount.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N664',
      description: 'Adjusted based on a legal settlement.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N665',
      description: 'Services by an unlicensed provider are not reimbursable.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N666',
      description:
        'Only one evaluation and management code at this service level is covered during the course of care.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N667',
      description:
        'Missing prescription.Start: 07/15/2013 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/15/2013 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N668',
      description:
        'Incomplete/invalid prescription.Start: 07/15/2013 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 07/15/2013 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N669',
      description: 'Adjusted based on the Medicare fee schedule.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N670',
      description:
        'This service code has been identified as the primary procedure code subject to the Medicare Multiple Procedure Payment Reduction (MPPR) rule.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N671',
      description: 'Payment based on a jurisdiction cost-charge ratio.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N672',
      description: 'Alert: Amount applied to Health Insurance Offset.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N673',
      description:
        'Reimbursement has been calculated based on an outpatient per diem or an outpatient factor and/or fee schedule amount.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N674',
      description:
        'Not covered unless a pre-requisite procedure/service has been provided.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N675',
      description: 'Additional information is required from the injured party.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N676',
      description:
        'Service does not qualify for payment under the Outpatient Facility Fee Schedule.Start: 07/15/2013',
      dates: 'Start: 07/15/2013'
    } as IRarHelper,
    {
      code: 'N677',
      description: 'Alert: Films/Images will not be returned.Start: 11/01/2013',
      dates: 'Start: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N678',
      description: 'Missing post-operative images/visual field results.Start: 11/01/2013',
      dates: 'Start: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N679',
      description:
        'Incomplete/Invalid post-operative images/visual field results.Start: 11/01/2013',
      dates: 'Start: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N680',
      description:
        'Missing/Incomplete/Invalid date of previous dental extractions.Start: 11/01/2013',
      dates: 'Start: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N681',
      description: 'Missing/Incomplete/Invalid full arch series.Start: 11/01/2013',
      dates: 'Start: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N682',
      description:
        'Missing/Incomplete/Invalid history of prior periodontal therapy/maintenance.Start: 11/01/2013',
      dates: 'Start: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N683',
      description: 'Missing/Incomplete/Invalid prior treatment documentation.Start: 11/01/2013',
      dates: 'Start: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N684',
      description:
        'Payment denied as this is a specialty claim submitted as a general claim.Start: 11/01/2013',
      dates: 'Start: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N685',
      description: 'Missing/Incomplete/Invalid Prosthesis, Crown or Inlay Code.Start: 11/01/2013',
      dates: 'Start: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N686',
      description:
        'Missing/incomplete/Invalid questionnaire needed to complete payment determination.Start: 11/01/2013',
      dates: 'Start: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N687',
      description:
        'Alert: This reversal is due to a retroactive disenrollment.Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)',
      dates:
        'Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N688',
      description:
        'Alert: This reversal is due to a medical or utilization review decision.Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)',
      dates:
        'Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N689',
      description:
        'Alert: This reversal is due to a retroactive rate change.Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)',
      dates:
        'Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N690',
      description:
        'Alert: This reversal is due to a provider submitted appeal.Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)',
      dates:
        'Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N691',
      description:
        'Alert: This reversal is due to a patient submitted appeal.Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)',
      dates:
        'Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N692',
      description:
        'Alert: This reversal is due to an incorrect rate on the initial adjudication.Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)',
      dates:
        'Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N693',
      description:
        'Alert: This reversal is due to a cancellation of the claim by the provider.Start: 11/01/2013 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 11/01/2013 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N694',
      description:
        'Alert: This reversal is due to a resubmission/change to the claim by the provider.Start: 11/01/2013',
      dates: 'Start: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N695',
      description:
        'Alert: This reversal is due to incorrect patient financial responsibility information on the initial adjudication.Start: 11/01/2013',
      dates: 'Start: 11/01/2013'
    } as IRarHelper,
    {
      code: 'N696',
      description:
        'Alert: This reversal is due to a Coordination of Benefits or Third Party Liability Recovery retroactive adjustment.Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)',
      dates:
        'Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N697',
      description:
        "Alert: This reversal is due to a payer's retroactive contract incentive program adjustment.Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)",
      dates:
        'Start: 11/01/2013 | Last Modified: 03/14/2014Notes: To be used with claim/service reversal. (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N698',
      description:
        'Alert: This reversal is due to non-payment of the health insurance premiums (Health Insurance Exchange or other) by the end of the premium payment grace period, resulting in loss of coverage.Start: 11/01/2013 | Last Modified: 11/01/2015Notes: To be used with claim/service reversal. (Modified 3/14/2014, 11/1/2015)',
      dates:
        'Start: 11/01/2013 | Last Modified: 11/01/2015Notes: To be used with claim/service reversal. (Modified 3/14/2014, 11/1/2015)'
    } as IRarHelper,
    {
      code: 'N699',
      description:
        'Payment adjusted based on the Physician Quality Reporting System (PQRS) Incentive Program.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N700',
      description:
        'Payment adjusted based on the Electronic Health Records (EHR) Incentive Program.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N701',
      description: 'Payment adjusted based on the Value-based Payment Modifier.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N702',
      description:
        'Decision based on review of previously adjudicated claims or for claims in process for the same/similar type of services.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N703',
      description:
        'This service is incompatible with previously  adjudicated claims or claims in process.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N704',
      description:
        'Alert: You may not appeal this decision but can resubmit this claim/service with corrected information if warranted.Start: 03/01/2014 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)',
      dates: 'Start: 03/01/2014 | Last Modified: 03/14/2014Notes: (Modified 3/14/2014)'
    } as IRarHelper,
    {
      code: 'N705',
      description: 'Incomplete/invalid documentation.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N706',
      description: 'Missing documentation.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N707',
      description: 'Incomplete/invalid orders.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N708',
      description: 'Missing orders.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N709',
      description: 'Incomplete/invalid notes.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N710',
      description: 'Missing notes.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N711',
      description: 'Incomplete/invalid summary.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N712',
      description: 'Missing summary.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N713',
      description: 'Incomplete/invalid report.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N714',
      description: 'Missing report.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N715',
      description: 'Incomplete/invalid chart.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N716',
      description: 'Missing chart.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N717',
      description: 'Incomplete/Invalid documentation of face-to-face examination.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N718',
      description: 'Missing documentation of face-to-face examination.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N719',
      description: 'Penalty applied based on plan requirements not being met.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N720',
      description:
        'Alert: The patient overpaid you. You may need to issue the patient a refund for the difference between the patient’s payment and the amount shown as patient responsibility on this notice.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N721',
      description:
        'This service is only covered when performed as part of a clinical trial.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N722',
      description:
        "Patient must use Workers' Compensation Set-Aside (WCSA) funds to pay for the medical service or item.Start: 03/01/2014",
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N723',
      description:
        'Patient must use Liability set-aside (LSA) funds to pay for the medical service or item.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N724',
      description:
        'Patient must use No-Fault set-aside (NFSA) funds to pay for the medical service or item.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N725',
      description:
        'A liability insurer has reported having ongoing responsibility for medical services (ORM) for this diagnosis.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N726',
      description: 'A conditional payment is not allowed.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N727',
      description:
        'A no-fault insurer has reported having ongoing responsibility for medical services (ORM) for this diagnosis.Start: 03/01/2014',
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N728',
      description:
        "A workers' compensation insurer has reported having ongoing responsibility for medical services (ORM) for this diagnosis.Start: 03/01/2014",
      dates: 'Start: 03/01/2014'
    } as IRarHelper,
    {
      code: 'N729',
      description: 'Missing patient medical/dental record for this service.Start: 11/01/2014',
      dates: 'Start: 11/01/2014'
    } as IRarHelper,
    {
      code: 'N730',
      description:
        'Incomplete/invalid patient medical/dental record for this service.Start: 11/01/2014',
      dates: 'Start: 11/01/2014'
    } as IRarHelper,
    {
      code: 'N731',
      description: 'Incomplete/Invalid mental health assessment.Start: 11/01/2014',
      dates: 'Start: 11/01/2014'
    } as IRarHelper,
    {
      code: 'N732',
      description:
        'Services performed at an unlicensed facility are not reimbursable.Start: 11/01/2014',
      dates: 'Start: 11/01/2014'
    } as IRarHelper,
    {
      code: 'N733',
      description: 'Regulatory surcharges are paid directly to the state.Start: 11/01/2014',
      dates: 'Start: 11/01/2014'
    } as IRarHelper,
    {
      code: 'N734',
      description:
        'The patient is eligible for these medical services only when unable to work or perform normal activities due to an illness or injury.Start: 11/01/2014',
      dates: 'Start: 11/01/2014'
    } as IRarHelper,
    {
      code: 'N735',
      description:
        'Adjustment without review of medical/dental record because the requested records were not received or were not received timely.Start: 03/01/2015 | Stop: 01/01/2016',
      dates: 'Start: 03/01/2015 | Stop: 01/01/2016'
    } as IRarHelper,
    {
      code: 'N736',
      description: 'Incomplete/invalid Sleep Study Report.Start: 03/01/2015',
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N737',
      description: 'Missing Sleep Study Report.Start: 03/01/2015',
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N738',
      description: 'Incomplete/invalid Vein Study Report.Start: 03/01/2015',
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N739',
      description: 'Missing Vein Study Report.Start: 03/01/2015',
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N740',
      description:
        "The Member's Consumer Spending Account does not contain sufficient funds to cover the Member's liability for this claim/service.Start: 03/01/2015",
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N741',
      description: 'This is a site neutral payment.Start: 03/01/2015',
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N742',
      description:
        'Alert: This claim was processed based on one or more ICD-9 codes. The transition to ICD-10 is required by October 1, 2015, for health care providers, health plans, and clearinghouses. More information can be found at http://www.cms.gov/Medicare/Coding/ICD10/ProviderResources.htmlStart: 03/01/2015 | Stop: 11/01/2016 | Last Modified: 11/01/2015Notes: (Modified 11/1/2015)',
      dates:
        'Start: 03/01/2015 | Stop: 11/01/2016 | Last Modified: 11/01/2015Notes: (Modified 11/1/2015)'
    } as IRarHelper,
    {
      code: 'N743',
      description:
        'Adjusted because the services may be related to an employment accident.Start: 03/01/2015',
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N744',
      description:
        'Adjusted because the services may be related to an auto/other accident.Start: 03/01/2015 | Last Modified: 03/01/2017Notes: (Modified 3/1/2017)',
      dates: 'Start: 03/01/2015 | Last Modified: 03/01/2017Notes: (Modified 3/1/2017)'
    } as IRarHelper,
    {
      code: 'N745',
      description: 'Missing Ambulance Report.Start: 03/01/2015',
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N746',
      description: 'Incomplete/invalid Ambulance Report.Start: 03/01/2015',
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N747',
      description:
        'This is a misdirected claim/service. Submit the claim to the payer/plan where the patient resides.Start: 03/01/2015',
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N748',
      description:
        'Adjusted because the related hospital charges have not been received.Start: 03/01/2015',
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N749',
      description: 'Missing Blood Gas Report.Start: 03/01/2015',
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N750',
      description: 'Incomplete/invalid Blood Gas Report.Start: 03/01/2015',
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N751',
      description:
        'Adjusted because the patient is covered under a Medicare Part D plan.Start: 03/01/2015 | Last Modified: 07/01/2017Notes: (Modified 7/1/2017)',
      dates: 'Start: 03/01/2015 | Last Modified: 07/01/2017Notes: (Modified 7/1/2017)'
    } as IRarHelper,
    {
      code: 'N752',
      description:
        'Missing/incomplete/invalid HIPPS Treatment Authorization Code (TAC).Start: 03/01/2015',
      dates: 'Start: 03/01/2015'
    } as IRarHelper,
    {
      code: 'N753',
      description: 'Missing/incomplete/invalid Attachment Control Number.Start: 07/01/2015',
      dates: 'Start: 07/01/2015'
    } as IRarHelper,
    {
      code: 'N754',
      description:
        'Missing/incomplete/invalid Referring Provider or Other Source Qualifier on the 1500 Claim Form.Start: 07/01/2015',
      dates: 'Start: 07/01/2015'
    } as IRarHelper,
    {
      code: 'N755',
      description:
        'Missing/incomplete/invalid ICD Indicator.Start: 07/01/2015 | Last Modified: 03/01/2016Notes: (Modified 3/1/2016)',
      dates: 'Start: 07/01/2015 | Last Modified: 03/01/2016Notes: (Modified 3/1/2016)'
    } as IRarHelper,
    {
      code: 'N756',
      description: 'Missing/incomplete/invalid point of drop-off address.Start: 07/01/2015',
      dates: 'Start: 07/01/2015'
    } as IRarHelper,
    {
      code: 'N757',
      description: 'Adjusted based on the Federal Indian Fees schedule (MLR).Start: 07/01/2015',
      dates: 'Start: 07/01/2015'
    } as IRarHelper,
    {
      code: 'N758',
      description: 'Adjusted based on the prior authorization decision.Start: 07/01/2015',
      dates: 'Start: 07/01/2015'
    } as IRarHelper,
    {
      code: 'N759',
      description:
        'Payment adjusted based on the National Electrical Manufacturers Association (NEMA) Standard XR-29-2013.Start: 07/01/2015',
      dates: 'Start: 07/01/2015'
    } as IRarHelper,
    {
      code: 'N760',
      description:
        'This facility is not authorized to receive payment for the service(s).Start: 11/01/2015',
      dates: 'Start: 11/01/2015'
    } as IRarHelper,
    {
      code: 'N761',
      description:
        'This provider is not authorized to receive payment for the service(s).Start: 11/01/2015',
      dates: 'Start: 11/01/2015'
    } as IRarHelper,
    {
      code: 'N762',
      description:
        'This facility is not certified for Tomosynthesis (3-D) mammography.Start: 11/01/2015',
      dates: 'Start: 11/01/2015'
    } as IRarHelper,
    {
      code: 'N763',
      description:
        'The demonstration code is not appropriate for this claim; resubmit without a demonstration code.Start: 11/01/2015',
      dates: 'Start: 11/01/2015'
    } as IRarHelper,
    {
      code: 'N764',
      description: 'Missing/incomplete/invalid Hematocrit (HCT) value.Start: 03/01/2016',
      dates: 'Start: 03/01/2016'
    } as IRarHelper,
    {
      code: 'N765',
      description:
        'This payer does not cover coinsurance assessed by a previous payer.Start: 03/01/2016 | Last Modified: 03/01/2018Notes: (Modified 3/1/2018)',
      dates: 'Start: 03/01/2016 | Last Modified: 03/01/2018Notes: (Modified 3/1/2018)'
    } as IRarHelper,
    {
      code: 'N766',
      description:
        'This payer does not cover co-payment assessed by a previous payer.Start: 03/01/2016',
      dates: 'Start: 03/01/2016'
    } as IRarHelper,
    {
      code: 'N767',
      description:
        'The Medicaid state requires provider to be enrolled in the member’s Medicaid state program prior to any claim benefits being processed.Start: 03/01/2016',
      dates: 'Start: 03/01/2016'
    } as IRarHelper,
    {
      code: 'N768',
      description: 'Incomplete/invalid initial evaluation report.Start: 03/01/2016',
      dates: 'Start: 03/01/2016'
    } as IRarHelper,
    {
      code: 'N769',
      description: 'A lateral diagnosis is required.Start: 03/01/2016',
      dates: 'Start: 03/01/2016'
    } as IRarHelper,
    {
      code: 'N770',
      description:
        'The adjustment request received from the provider has been processed. Your original claim has been adjusted based on the information received.Start: 03/01/2016',
      dates: 'Start: 03/01/2016'
    } as IRarHelper,
    {
      code: 'N771',
      description:
        'Alert: Under Federal law you cannot charge more than the limiting charge amount.Start: 07/01/2016',
      dates: 'Start: 07/01/2016'
    } as IRarHelper,
    {
      code: 'N772',
      description:
        'Alert: Rebill urgent/emergent and ancillary services separately.Start: 07/01/2016',
      dates: 'Start: 07/01/2016'
    } as IRarHelper,
    {
      code: 'N773',
      description: 'Drug supplied not obtained from specialty vendor.Start: 07/01/2016',
      dates: 'Start: 07/01/2016'
    } as IRarHelper,
    {
      code: 'N774',
      description:
        'Alert: Refer to your Third Party Processor Agreement for specific information on fees associated with this payment type.Start: 07/01/2016',
      dates: 'Start: 07/01/2016'
    } as IRarHelper,
    {
      code: 'N775',
      description: 'Payment adjusted based on x-ray radiograph on film.Start: 11/01/2016',
      dates: 'Start: 11/01/2016'
    } as IRarHelper,
    {
      code: 'N776',
      description: 'This service is not a covered Telehealth service.Start: 11/01/2016',
      dates: 'Start: 11/01/2016'
    } as IRarHelper,
    {
      code: 'N777',
      description:
        'Missing Assignment of Benefits Indicator.Start: 11/01/2016 | Last Modified: 03/01/2017Notes: (Modified 3/1/2017)',
      dates: 'Start: 11/01/2016 | Last Modified: 03/01/2017Notes: (Modified 3/1/2017)'
    } as IRarHelper,
    {
      code: 'N778',
      description: 'Missing Primary Care Physician Information.Start: 11/01/2016',
      dates: 'Start: 11/01/2016'
    } as IRarHelper,
    {
      code: 'N779',
      description:
        'Replacement/Void claims cannot be submitted until the original claim has finalized. Please resubmit once payment or denial is received.Start: 11/01/2016',
      dates: 'Start: 11/01/2016'
    } as IRarHelper,
    {
      code: 'N780',
      description: 'Missing/incomplete/invalid end therapy date.Start: 11/01/2016',
      dates: 'Start: 11/01/2016'
    } as IRarHelper,
    {
      code: 'N781',
      description:
        'Alert: Patient is a Medicaid/ Qualified Medicare Beneficiary. Review your records for any wrongfully collected deductible. This amount may be billed to a subsequent payer.Start: 11/01/2016 | Last Modified: 03/01/2018Notes: (Modified 3/1/2018)',
      dates: 'Start: 11/01/2016 | Last Modified: 03/01/2018Notes: (Modified 3/1/2018)'
    } as IRarHelper,
    {
      code: 'N782',
      description:
        'Alert: Patient is a Medicaid/ Qualified Medicare Beneficiary. Review your records for any wrongfully collected coinsurance. This amount may be billed to a subsequent payer.Start: 11/01/2016 | Last Modified: 03/01/2018Notes: (Modified 3/1/2018)',
      dates: 'Start: 11/01/2016 | Last Modified: 03/01/2018Notes: (Modified 3/1/2018)'
    } as IRarHelper,
    {
      code: 'N783',
      description:
        'Alert: Patient is a Medicaid/ Qualified Medicare Beneficiary. Review your records for any wrongfully collected copayment. This amount may be billed to a subsequent payer.Start: 11/01/2016 | Last Modified: 03/01/2018Notes: (Modified 3/1/2018)',
      dates: 'Start: 11/01/2016 | Last Modified: 03/01/2018Notes: (Modified 3/1/2018)'
    } as IRarHelper,
    {
      code: 'N784',
      description: 'Missing comprehensive procedure code.Start: 11/01/2016',
      dates: 'Start: 11/01/2016'
    } as IRarHelper,
    {
      code: 'N785',
      description: 'Missing current radiology film/images.Start: 11/01/2016',
      dates: 'Start: 11/01/2016'
    } as IRarHelper,
    {
      code: 'N786',
      description:
        'Benefit limitation for the orthodontic active and/or retention phase of treatment.Start: 11/01/2016',
      dates: 'Start: 11/01/2016'
    } as IRarHelper,
    {
      code: 'N787',
      description:
        'Alert: Under 42 CFR 410.43, an eligible Partial Hospitalization Program (PHP) patient/beneficiary requires a minimum of 20 hours of PHP services per week, as evidenced in the plan of care. PHP services must be furnished in accordance with the plan of care.Start: 03/01/2017',
      dates: 'Start: 03/01/2017'
    } as IRarHelper,
    {
      code: 'N788',
      description:
        'The third party administrator/review organization did not receive the required information.Start: 03/01/2017 | Last Modified: 11/01/2017Notes: (Modified 11/1/2017)',
      dates: 'Start: 03/01/2017 | Last Modified: 11/01/2017Notes: (Modified 11/1/2017)'
    } as IRarHelper,
    {
      code: 'N789',
      description: 'Clinical Trial is not a covered benefit.Start: 07/01/2017',
      dates: 'Start: 07/01/2017'
    } as IRarHelper,
    {
      code: 'N790',
      description: 'Provider/supplier not accredited for product/service.Start: 07/01/2017',
      dates: 'Start: 07/01/2017'
    } as IRarHelper,
    {
      code: 'N791',
      description: 'Missing history & physical report.Start: 07/01/2017',
      dates: 'Start: 07/01/2017'
    } as IRarHelper,
    {
      code: 'N792',
      description: 'Incomplete/invalid history & physical report.Start: 07/01/2017',
      dates: 'Start: 07/01/2017'
    } as IRarHelper,
    {
      code: 'N793',
      description:
        'Alert: CMS is changing from the Medicare Health Insurance Claim number (HICN) to the new Medicare Beneficiary Identifier (MBI). You can use either the HICN or MBI during the transition period. Visit www.cms.gov/newcard for important dates and information about this change.Start: 07/01/2017 | Last Modified: 11/01/2017Notes: (Modified 11/1/2017)',
      dates: 'Start: 07/01/2017 | Last Modified: 11/01/2017Notes: (Modified 11/1/2017)'
    } as IRarHelper,
    {
      code: 'N794',
      description: 'Payment adjusted based on type of technology used.Start: 07/01/2017',
      dates: 'Start: 07/01/2017'
    } as IRarHelper,
    {
      code: 'N795',
      description: 'Item must be resubmitted as a purchase.Start: 11/01/2017',
      dates: 'Start: 11/01/2017'
    } as IRarHelper,
    {
      code: 'N796',
      description: 'Missing/incomplete/invalid Hemoglobin (Hb or Hgb) value.Start: 11/01/2017',
      dates: 'Start: 11/01/2017'
    } as IRarHelper,
    {
      code: 'N797',
      description: 'Missing/incomplete/invalid date qualifier.Start: 11/01/2017',
      dates: 'Start: 11/01/2017'
    } as IRarHelper,
    {
      code: 'N798',
      description:
        'Submit a void request for the original claim and resubmit a new claim.Start: 11/01/2017',
      dates: 'Start: 11/01/2017'
    } as IRarHelper,
    {
      code: 'N799',
      description:
        'Submitted identifier must be an individual identifier, not group identifier.Start: 11/01/2017 | Last Modified: 03/01/2018Notes: (Modified 3/1/2018)',
      dates: 'Start: 11/01/2017 | Last Modified: 03/01/2018Notes: (Modified 3/1/2018)'
    } as IRarHelper,
    {
      code: 'N800',
      description: 'Only one service date is allowed per claim.Start: 03/01/2018',
      dates: 'Start: 03/01/2018'
    } as IRarHelper,
    {
      code: 'N801',
      description:
        'Services performed in a Medicare participating or CAH facility under a self-insured tribal Group Health Plan, in accordance with Federal Regulation 42 CFR 136.Start: 03/01/2018',
      dates: 'Start: 03/01/2018'
    } as IRarHelper,
    {
      code: 'N802',
      description:
        'This claim/service is not payable under our service area. The claim must be filed to the Payer/Plan in whose service area the Rendering Physician is located.Start: 03/01/2018',
      dates: 'Start: 03/01/2018'
    } as IRarHelper,
    {
      code: 'N803',
      description:
        'Submission of the claim for the service rendered is the responsibility of the Contracted Medical Group or Hospital.Start: 03/01/2018',
      dates: 'Start: 03/01/2018'
    } as IRarHelper
  ]
}
